<template>
  <v-container fluid style="height:100%;padding-bottom:500px;" pa-0 ma-0>
    <!-- SALES REPORT-->
    <!-- <PerformanceBar/> -->
    <!-- <div id="tomi-button"   v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" style="position:fixed;top:62px;left:10px;background:#000;border-radius:5px;z-index:200"><span @click="saveReportBase()" style="padding-right:5px;padding-left:5px;color:#FFF;font-size:9px;" class="pr-1">Tallenna pohja</span></div>
    <div id="tomi-button2"  v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" style="position:fixed;top:62px;left:100px;background:#000;border-radius:5px;z-index:200"><span @click="loadSalespersonsBase();loadCompaniesAndProductVariationsBase();" style="padding-right:5px;padding-left:5px;color:#FFF;font-size:9px;" class="pr-1">Hae viimesimmät tiedot</span></div> -->
    <v-tabs
      fixed-tabs
      dark
      dense
      height="30"
      v-model="selectedReportTab"
      class="promotion-tabs pb-1"
      background-color="#136DF5"
      style="position:fixed;top:35px;z-index:100;"
    >
      <v-tabs-slider color="#FFF" ></v-tabs-slider>
      <v-tab href="#salesperson">Myyjät</v-tab>
      <v-tab href="#company" v-if="allAccess">Logogear</v-tab>
      <v-tab href="#scorecard" v-if="allAccess">Scorecard</v-tab>
      <v-tab href="#competition">Kilpailut</v-tab>
      <v-tab href="#top">Top tuotteet ja asiakkaat</v-tab>
    </v-tabs>
    <div class="text-center" style="background-color:#000;color:#FFF;font-size:14px;padding-top:30px;">
      ❗Raportin luvut päivittyvät arkisin klo 8, 10, 12, 14, 16 ja 18. Poikkeuksena 'top tuotteet ja asiakkaat' luvut pävittyvät aina kuun 1 ja 15 päivä klo 8:00 ❗
      <v-btn v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" @click="saveReportBase();" color="#000000" dark class="avecor-button-global small-add-button mr-3">Tallenna pohja</v-btn>
      <v-btn v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" @click="loadSalespersonsBase();loadCompaniesAndProductVariationsBase();" color="#000000" dark class="avecor-button-global small-add-button mr-3">Hae viimesimmät tiedot</v-btn>
    </div>
    <div class="">
      <!-- MYYJÄT -->
      <div v-if="selectedReportTab == 'salesperson'" class="no-scrollbars" style="height:100%;overflow-y:scroll;padding-bottom:300px;">
        <!-- <div class="mt-5"/> -->
        <!-- <v-divider></v-divider> -->
        <div v-for="(salesperson, index) in getSalespersons()" :key="salesperson.id+'-performance-row'">
          <v-lazy
            :style="device === 'mobile' ? 'width:100%; padding:0px; margin:0px;min-height:800px' : 'width:100%; padding:0px; margin:0px;min-height:300px'"
            :options="{
              threshold: .1
            }"
            v-if="staff[user.uid].isAdmin || user.uid === salesperson.id" 
          >
            <div>
              <!-- MOBILE -->
              <div v-if="device === 'mobile'">
                <v-row  no-gutters style="background:#136DF5;/*background:rgb(25, 25, 25);*/">
                  <v-col cols="12">
                    <v-card
                      style="border-radius:0px; -webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; "
                      color="#191919"
                      dark
                    >
                      <v-card-title class="justify-center">
                        <span class="font-weight-heavy">{{salesperson.firstName}}</span>
                      </v-card-title>
                      <v-card-text class="pb-0 headline font-weight-bold a-white">
                        <v-row no-gutters style="font-size:12px;">
                          <v-col cols="3" style="font-size:14px; height:100%;" class="text-left"> Myynti</v-col>
                          <v-col cols="3" class="text-center">
                            <div>Toteutuma {{(getTotalNew(salesperson.id,"sales","thisYear")/1000).toFixed(2)}}k€</div>
                          </v-col>
                          <v-col cols="3" class="text-center" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                            <div>Tavoite {{(getTotalNew(salesperson.id,"salesGoals","thisYear")/1000).toFixed(2)}}k€</div>
                          </v-col>
                          <v-col cols="3" class="text-right" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                            <div style="color:orange;font-size:17px">{{((getTotalNew(salesperson.id,"sales","thisYear")/getTotalNew(salesperson.id,"salesGoals","thisYear"))*100).toFixed(2)}}%</div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card
                      style="border-radius:0px; -webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; "
                      color="#191919"
                      dark
                    >
                      <v-card-text class="py-0 headline font-weight-bold a-white">
                        <v-row no-gutters style="font-size:12px;">
                          <v-col cols="3" style="font-size:14px; height:100%;" class="text-left"> Kate</v-col>
                          <v-col cols="3" class="text-center">
                            <div>Toteutuma {{(getTotalNew(salesperson.id,"margins","thisYear")/1000).toFixed(2)}}k€</div>
                          </v-col>
                          <v-col cols="6" class="text-right" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'"></v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card
                      style="border-radius:0px; -webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; "
                      color="#191919"
                      dark
                    >
                      <v-card-text class="py-0 headline font-weight-bold a-white">
                        <v-row no-gutters style="font-size:12px;">
                          <v-col cols="3" style="font-size:14px; height:100%;" class="text-left"> Katekerroin</v-col>
                          <v-col cols="3" class="text-center">
                            <div>Toteutuma {{getTotalNew(salesperson.id,"marginRate","thisYear").toFixed(2)}}</div>
                          </v-col>
                          <v-col cols="3" class="text-center" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                            <div>Tavoite {{getTotalNew(salesperson.id,"marginRateGoals","thisYear").toFixed(2)}}</div>
                          </v-col>
                          <v-col cols="3" class="text-right" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                            <div style="color:orange;font-size:17px">{{((getTotalNew(salesperson.id,"marginRate","thisYear")/getTotalNew(salesperson.id,"marginRateGoals","thisYear"))*100).toFixed(2)}}%</div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card
                      style="border-radius:0px; -webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; "
                      color="#191919"
                      dark
                    >
                      <v-card-text class="py-0 headline font-weight-bold a-white">
                        <v-row no-gutters style="font-size:12px;">
                          <v-col cols="3" style="font-size:14px; height:100%;" class="text-left"> Tilaukset</v-col>
                          <v-col cols="3" class="text-center">
                            <div>Toteutuma {{getTotalNew(salesperson.id,"orders","thisYear")}}</div>
                          </v-col>
                          <v-col cols="6" class="text-right" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'"></v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card
                      style="border-radius:0px; -webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; "
                      color="#191919"
                      dark
                    >
                      <v-card-text class="py-0 headline font-weight-bold a-white">
                        <v-row no-gutters style="font-size:12px;">
                          <v-col cols="3" style="font-size:14px; height:100%;" class="text-left"> Uudet asiakkaat</v-col>
                          <v-col cols="3" class="text-center">
                            <div>Toteutuma {{getTotalNew(salesperson.id,"newCustomers","thisYear")}}</div>
                          </v-col>
                          <v-col cols="6" class="text-right" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'"></v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
              <!-- MOBILE -->
              <div v-if="device === 'mobile'">
                <v-row no-gutters >
                  <v-col cols="6" style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" :title="salesperson.firstName + ' myynti 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'sales','months',2026), week:getChartData(salesperson.id, 'sales','weeks',2026)}" />
                  </v-col>
                  <v-col cols="6">
                    <ReportChart type="bar" :title="salesperson.firstName + ' myynti 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'sales','months',2025), week:getChartData(salesperson.id, 'sales','weeks',2025)}" />
                  </v-col>
                  <v-col cols="6" style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" :title="salesperson.firstName + ' kate 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'margins','months',2026), week:getChartData(salesperson.id, 'margins','weeks',2026)}" />
                  </v-col>
                  <v-col cols="6">
                    <ReportChart type="bar" :title="salesperson.firstName + ' kate 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'margins','months',2025), week:getChartData(salesperson.id, 'margins','weeks',2025)}" />
                  </v-col>
                  <v-col cols="6" style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" :title="salesperson.firstName + ' katekerroin 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'marginRate','months',2026), week:getChartData(salesperson.id, 'marginRate','weeks',2026)}" />
                  </v-col>
                  <v-col cols="6">
                    <ReportChart type="bar" :title="salesperson.firstName + ' katekerroin 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'marginRate','months',2025), week:getChartData(salesperson.id, 'marginRate','weeks',2025)}" />
                  </v-col>
                  <v-col cols="6" style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" :title="salesperson.firstName + ' tilaukset 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'orders','months',2026), week:getChartData(salesperson.id, 'orders','weeks',2026)}" />
                  </v-col>
                  <v-col cols="6">
                    <ReportChart type="bar" :title="salesperson.firstName + ' tilaukset 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'orders','months',2025), week:getChartData(salesperson.id, 'orders','weeks',2025)}" />
                  </v-col>
                  <v-col cols="6" style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" :title="salesperson.firstName + ' uudet asiakkaat 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'newCustomers','months',2026), week:getChartData(salesperson.id, 'newCustomers','weeks',2026)}" />
                  </v-col>
                  <v-col cols="6">
                    <ReportChart type="bar" :title="salesperson.firstName + ' uudet asiakkaat 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'newCustomers','months',2025), week:getChartData(salesperson.id, 'newCustomers','weeks',2025)}" />
                  </v-col>
                </v-row>
              </div>
              <!-- DESKTOP -->
              <div v-if="device === 'desktop'">
                <v-row  no-gutters style="background:#136DF5;/*background:rgb(25, 25, 25);*/">
                  <v-col :class="salesperson.weekReportingRequired ? 'pr-2 col-2' : 'pr-2 lg5-custom'">
                    <v-card dark color="#191919" style="border-radius:0px; -webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                      <v-card-title class="justify-center">
                        <v-icon small left>fas fa-euro-sign</v-icon>
                        <span class="font-weight-heavy">{{salesperson.firstName}} vuoden myynti</span>
                      </v-card-title>
                      <v-card-text class="headline font-weight-bold text-center a-white">
                          <v-row no-gutters style="font-size:12px;">
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                              <div>Toteutuma</div>
                              <div><span style="font-size:10px;color:#000" class="pr-1">2026:</span>{{(getTotalNew(salesperson.id,"sales","thisYear")/1000).toFixed(2)}}k€</div>
                              <div><span style="font-size:10px;color:#000" class="pr-1">2025:</span>{{(getTotalNew(salesperson.id,"sales","lastYear")/1000).toFixed(2)}}k€</div>
                            </v-col>
                            <v-col cols="4" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                              <div>Tavoite</div>
                              <div>{{(getTotalNew(salesperson.id,"salesGoals","thisYear")/1000).toFixed(2)}}k€</div>
                              <div>{{(getTotalNew(salesperson.id,"salesGoals","lastYear")/1000).toFixed(2)}}k€</div>
                            </v-col>
                            <v-col cols="3" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                              <div>_</div>
                              <div style="color:orange;">{{((getTotalNew(salesperson.id,"sales","thisYear")/getTotalNew(salesperson.id,"salesGoals","thisYear"))*100).toFixed(2)}}%</div>
                              <div style="color:orange;">{{((getTotalNew(salesperson.id,"sales","lastYear")/getTotalNew(salesperson.id,"salesGoals","lastYear"))*100).toFixed(2)}}%</div>
                            </v-col>
                            <!-- <v-col cols="1"></v-col> -->
                          </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col :class="salesperson.weekReportingRequired ? 'pr-2 col-2' : 'pr-2 lg5-custom'">
                    <v-card dark color="#191919" style="border-radius:0px; -webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                      <v-card-title class="justify-center">
                        <v-icon small left>fas fa-euro-sign</v-icon>
                        <span class="font-weight-heavy">{{salesperson.firstName}} vuoden kate</span>
                      </v-card-title>
                      <v-card-text class="mt-3 headline font-weight-bold text-center a-white" v-if="new Date().getFullYear() < 2026">
                        {{(getTotalNew(salesperson.id,"margins","thisYear")/1000).toFixed(2)}}k€
                      </v-card-text>
                      <v-card-text class="mt-3 headline font-weight-bold text-center a-white" v-else>
                        <v-row no-gutters style="font-size:12px;">
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                              <div>Toteutuma</div>
                              <div><span style="font-size:10px;color:#000" class="pr-1">2026:</span>{{(getTotalNew(salesperson.id,"margins","thisYear")/1000).toFixed(2)}}k€</div>
                              <div><span style="font-size:10px;color:#000" class="pr-1">2025:</span>{{(getTotalNew(salesperson.id,"margins","lastYear")/1000).toFixed(2)}}k€</div>
                            </v-col>
                            <v-col cols="4" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                              <div>Tavoite</div>
                              <div>{{(getTotalNew(salesperson.id,"marginGoals","thisYear")/1000).toFixed(2)}}k€</div>
                              <!-- <div>{{(getTotalNew(salesperson.id,"salesGoals","lastYear")/1000).toFixed(2)}}k€</div> -->
                            </v-col>
                            <v-col cols="3" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                              <div>_</div>
                              <div style="color:orange;" v-if="getTotalNew('all','marginGoals','thisYear') > 0">{{((getTotalNew(salesperson.id,"margins","thisYear")/getTotalNew(salesperson.id,"marginGoals","thisYear"))*100).toFixed(2)}}%</div>
                              <!-- <div style="color:orange;">{{((getTotalNew(salesperson.id,"sales","lastYear")/getTotalNew(salesperson.id,"salesGoals","lastYear"))*100).toFixed(2)}}%</div> -->
                            </v-col>
                            <!-- <v-col cols="1"></v-col> -->
                          </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col :class="salesperson.weekReportingRequired ? 'pr-2 col-2' : 'pr-2 lg5-custom'">
                    <v-card dark color="#191919" style="border-radius:0px; -webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                      <v-card-title class="justify-center">
                        <v-icon small left>fas fa-times</v-icon>
                        <span class="font-weight-heavy">{{salesperson.firstName}} vuoden katekerroin</span>
                      </v-card-title>
                      <v-card-text class="mt-3 headline font-weight-bold text-center a-white">
                        <v-row no-gutters style="font-size:12px;">
                          <v-col cols="2"></v-col>
                            <v-col cols="3">
                              <div>Toteutuma</div>
                              <div>{{getTotalNew(salesperson.id,"marginRate","thisYear").toFixed(2)}}</div>
                            </v-col>
                            <v-col cols="3" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                              <div>Tavoite</div>
                              <div>{{getTotalNew(salesperson.id,"marginRateGoals","thisYear").toFixed(2)}}</div>
                            </v-col>
                            <v-col cols="3" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                              <div>_</div>
                              <div style="color:orange;">{{((getTotalNew(salesperson.id,"marginRate","thisYear")/getTotalNew(salesperson.id,"marginRateGoals","thisYear"))*100).toFixed(2)}}%</div>
                            </v-col>
                            <v-col cols="1"></v-col>
                          </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col :class="salesperson.weekReportingRequired ? 'pr-2 col-2' : 'pr-2 lg5-custom'">
                    <v-card dark color="#191919" style="border-radius:0px; -webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                      <v-card-title class="justify-center">
                        <v-icon small left>fas fa-file-invoice-dollar</v-icon>
                        <span class="font-weight-heavy">{{salesperson.firstName}} vuoden tilaukset</span>
                      </v-card-title>
                      <v-card-text class="mt-3 headline font-weight-bold text-center a-white">
                        {{getTotalNew(salesperson.id,"orders","thisYear")}}
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col :class="salesperson.weekReportingRequired ? 'pr-2 col-2' : 'pr-2 lg5-custom'">
                    <v-card dark color="#191919" style="border-radius:0px; -webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                      <v-card-title class="justify-center">
                        <v-icon small left>far fa-handshake</v-icon>
                        <span class="font-weight-heavy">{{salesperson.firstName}} vuoden uudet asiakkaat</span>
                      </v-card-title>
                      <v-card-text class="mt-3 headline font-weight-bold text-center a-white">
                        {{getTotalNew(salesperson.id,"newCustomers","thisYear")}}
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col v-if="salesperson.weekReportingRequired" :class="salesperson.weekReportingRequired ? 'pr-2 col-2' : 'pr-2 lg5-custom'">
                    <v-card dark color="#191919" style="border-radius:0px; -webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                      <v-card-title class="justify-center">
                        <v-icon small left>far fa-id-card</v-icon>
                        <span class="font-weight-heavy">{{salesperson.firstName}} vuoden sovitut tap.</span>
                      </v-card-title>
                      <v-card-text class="mt-3 headline font-weight-bold text-center a-white">
                        {{getTotalNew(salesperson.id,"agreedVisits","thisYear")}}
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
              <div v-if="device === 'desktop'">
                <v-row no-gutters>
                  <v-col cols="2" :class="salesperson.weekReportingRequired ? 'pr-2' : 'pr-2 lg5-custom' " style="border-right:1px dotted #ccc; ">
                      <ReportChart type="bar" :title="salesperson.firstName + ' myynti 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'sales','months',2026), week:getChartData(salesperson.id, 'sales','weeks',2026)}" />
                      <ReportChart type="bar" :title="salesperson.firstName + ' myynti 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'sales','months',2025), week:getChartData(salesperson.id, 'sales','weeks',2025)}" />
                  </v-col>
                  <v-col cols="2" :class="salesperson.weekReportingRequired ? 'pr-2' : 'pr-2 lg5-custom' " style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" :title="salesperson.firstName + ' kate 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'margins','months',2026), week:getChartData(salesperson.id, 'margins','weeks',2026)}" />
                    <ReportChart type="bar" :title="salesperson.firstName + ' kate 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'margins','months',2025), week:getChartData(salesperson.id, 'margins','weeks',2025)}" />
                  </v-col>
                  <v-col cols="2" :class="salesperson.weekReportingRequired ? 'pr-2' : 'pr-2 lg5-custom' " style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" :title="salesperson.firstName + ' katekerroin 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'marginRate','months',2026), week:getChartData(salesperson.id, 'marginRate','weeks',2026)}" />
                    <ReportChart type="bar" :title="salesperson.firstName + ' katekerroin 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'marginRate','months',2025), week:getChartData(salesperson.id, 'marginRate','weeks',2025)}" />
                  </v-col>
                  <v-col cols="2" :class="salesperson.weekReportingRequired ? 'pr-2' : 'pr-2 lg5-custom' " style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" :title="salesperson.firstName + ' tilaukset 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'orders','months',2026), week:getChartData(salesperson.id, 'orders','weeks',2026)}" />
                    <ReportChart type="bar" :title="salesperson.firstName + ' tilaukset 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'orders','months',2025), week:getChartData(salesperson.id, 'orders','weeks',2025)}" />
                  </v-col>
                  <v-col cols="2" :class="salesperson.weekReportingRequired ? 'pr-2' : 'pr-2 lg5-custom' " style="border-right:1px dotted #ccc; ">
                      <ReportChart type="bar" :title="salesperson.firstName + ' uudet asiakkaat 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'newCustomers','months',2026), week:getChartData(salesperson.id, 'newCustomers','weeks',2026)}" />
                      <ReportChart type="bar" :title="salesperson.firstName + ' uudet asiakkaat 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'newCustomers','months',2025), week:getChartData(salesperson.id, 'newCustomers','weeks',2025)}" />
                  </v-col>
                  <v-col cols="2" v-if="salesperson.weekReportingRequired" :class="salesperson.weekReportingRequired ? 'pr-2' : 'pr-2 lg5-custom' ">
                    <ReportChart type="bar" :title="salesperson.firstName + ' sovitut tapaamiset 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData(salesperson.id, 'agreedVisits','months',2026), week:getChartData(salesperson.id, 'agreedVisits','weeks',2026)}" />
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-lazy>
        </div>
      </div>
      
      <!-- AVECOR -->  
      <div v-if="selectedReportTab === 'company'" class="no-scrollbars" style="height:100%;overflow-y:scroll;padding-bottom:300px;">
        <!-- AVECOR::MOBILE -->
        <div v-if="device === 'mobile'">
          <v-row  no-gutters style="background:#136DF5;/*background:rgb(25, 25, 25);*/">
            <v-col cols="12">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                
                <v-card-text class="pb-0 headline font-weight-bold a-white">
                  <v-row no-gutters style="font-size:12px;">
                    <v-col cols="3" style="font-size:14px; height:100%;" class="text-left"> Myynti</v-col>
                    <v-col cols="3" class="text-center">
                      <div>Toteutuma {{(getTotalNew("all","sales","thisYear")/1000).toFixed(2)}}k€</div>
                    </v-col>
                    <v-col cols="3" class="text-center" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                      <div>Tavoite {{(getTotalNew("all","salesGoals","thisYear")/1000).toFixed(2)}}k€</div>
                    </v-col>
                    <v-col cols="3" class="text-right" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                      <div style="color:orange;font-size:17px">{{((getTotalNew("all","sales","thisYear")/getTotalNew("all","salesGoals","thisYear"))*100).toFixed(2)}}%</div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" v-if="allAccess">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-text class="py-0 headline font-weight-bold a-white">
                  <v-row no-gutters style="font-size:12px;">
                    <v-col cols="3" style="font-size:14px; height:100%;" class="text-left"> Kate</v-col>
                    <v-col cols="3" class="text-center">
                      <div>Toteutuma {{(getTotalNew("all","margins","thisYear")/1000).toFixed(2)}}k€</div>
                    </v-col>
                    <v-col cols="6" class="text-right" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'"></v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <!-- <v-col cols="12">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-text class="py-0 headline font-weight-bold a-white">
                  <v-row no-gutters style="font-size:12px;">
                    <v-col cols="3" style="font-size:14px; height:100%;" class="text-left"> Katekerroin</v-col>
                    <v-col cols="3" class="text-center">
                      <div>Toteutuma {{getTotalNew("all","marginRate","thisYear").toFixed(2)}}</div>
                    </v-col>
                    <v-col cols="3" class="text-center" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                      <div>Tavoite {{getTotalNew("all","marginRateGoals","thisYear").toFixed(2)}}</div>
                    </v-col>
                    <v-col cols="3" class="text-right" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'">
                      <div style="color:orange;font-size:17px">{{((getTotalNew("all","marginRate","thisYear")/getTotalNew("all","marginRateGoals","thisYear"))*100).toFixed(2)}}%</div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col> -->
            <v-col cols="12">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-text class="py-0 headline font-weight-bold a-white">
                  <v-row no-gutters style="font-size:12px;">
                    <v-col cols="3" style="font-size:14px; height:100%;" class="text-left"> Tilaukset</v-col>
                    <v-col cols="3" class="text-center">
                      <div>{{getTotalNew("all","orders","thisYear")}}</div>
                    </v-col>
                    <v-col cols="6" class="text-right" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'"></v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-text class="py-0 headline font-weight-bold a-white">
                  <v-row no-gutters style="font-size:12px;">
                    <v-col cols="3" style="font-size:14px; height:100%;" class="text-left"> Uudet asiakkaat</v-col>
                    <v-col cols="3" class="text-center">
                      <div>{{getTotalNew("all","newCustomers","thisYear")}}</div>
                    </v-col>
                    <v-col cols="6" class="text-right" v-if="user.uid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1'"></v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters >
            <v-col cols="6" style="border-right:1px dotted #ccc; ">
              <ReportChart type="bar" title="Myynti 2026" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'sales','months',2026), week:getChartData('all', 'sales','weeks',2026)}" />
            </v-col>
            <v-col cols="6">
                <ReportChart type="bar" title="Myynti 2025" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'sales','months',2025), week:getChartData('all', 'sales','weeks',2025)}" />
            </v-col>
            <v-col cols="6" style="border-right:1px dotted #ccc; " v-if="allAccess">
              <ReportChart type="bar" title="Kate 2026" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'margins','months',2026), week:getChartData('all', 'margins','weeks',2026)}" />
            </v-col>
            <v-col cols="6" v-if="allAccess">
              <ReportChart type="bar" title="Kate 2025" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'margins','months',2025), week:getChartData('all', 'margins','weeks',2025)}" />
            </v-col>
            <v-col cols="6" style="border-right:1px dotted #ccc; ">
              <ReportChart type="bar" title="Katekerroin 2026" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'marginRate','months',2026), week:getChartData('all', 'marginRate','weeks',2026)}" />
            </v-col>
            <v-col cols="6">
              <ReportChart type="bar" title="Katekerroin 2025" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'marginRate','months',2025), week:getChartData('all', 'marginRate','weeks',2025)}" />
            </v-col>
            <v-col cols="6" style="border-right:1px dotted #ccc; ">
                <ReportChart type="bar" title="Tilaukset 2026" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'orders','months',2026), week:getChartData('all', 'orders','weeks',2026)}" />
            </v-col>
            <v-col cols="6">
              <ReportChart type="bar" title="Tilaukset 2025" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'orders','months',2025), week:getChartData('all', 'orders','weeks',2025)}" />
            </v-col>
            <v-col cols="6" style="border-right:1px dotted #ccc; ">
                <ReportChart type="bar" title="Uudet asiakkaat 2026" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'newCustomers','months',2026), week:getChartData('all', 'newCustomers','weeks',2026)}" />
            </v-col>
            <v-col cols="6">
              <ReportChart type="bar" title="'Uudet asiakkaat 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'newCustomers','months',2025), week:getChartData('all', 'newCustomers','weeks',2025)}" />
            </v-col>
          </v-row>
        </div>
        <!-- AVECOR::DESKTOP -->
        <div v-if="device === 'desktop'">
          <v-row no-gutters style="background:#136DF5;">
            <!-- MYYNTI -->
            <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-title class="justify-center">
                  <v-icon small left>fas fa-euro-sign</v-icon>
                  <span class="font-weight-heavy">Logogear vuoden myynti</span>
                </v-card-title>
                <v-card-text class="headline font-weight-bold text-center a-white">
                    <v-row no-gutters style="font-size:14px;">
                      <v-col cols="1"></v-col>
                      <v-col cols="4">
                        <div>Toteutuma</div>
                        <div><span style="font-size:10px;color:#000">2026:</span> {{(getTotalNew("all","sales","thisYear")/1000).toFixed(1)}}k€</div>
                        <div><span style="font-size:10px;color:#000">2025:</span> {{(getTotalNew("all","sales","lastYear")/1000).toFixed(1)}}k€</div>
                      </v-col>
                      <v-col cols="4">
                        <div>Tavoite</div>
                        <div>{{(getTotalNew("all","salesGoals","thisYear")/1000).toFixed(2)}}k€</div>
                        <div>{{(getTotalNew("all","salesGoals","lastYear")/1000).toFixed(2)}}k€</div>
                      </v-col>
                      <v-col cols="2">
                        <div>_</div>
                        <div style="color:orange;">{{((getTotalNew("all","sales","thisYear")/getTotalNew("all","salesGoals","thisYear"))*100).toFixed(1)}}%</div>
                        <div style="color:orange;">{{((getTotalNew("all","sales","lastYear")/getTotalNew("all","salesGoals","lastYear"))*100).toFixed(1)}}%</div>
                      </v-col>
                      <v-col cols="1"></v-col>
                    </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <!-- ADMIN: KATE -->
            <v-col v-if="staff[user.uid].isAdmin" :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-title class="justify-center">
                  <v-icon small left>fas fa-euro-sign</v-icon>
                  <span class="font-weight-heavy">Logogear vuoden kate</span>
                </v-card-title>
                <v-card-text class="mt-3 headline font-weight-bold text-center a-white" v-if="new Date().getFullYear() < 2026">
                  <div><span style="font-size:11px;color:#000">2026:</span> {{(getTotalNew("all","margins","thisYear")/1000).toFixed(1)}}k€</div>
                  <div><span style="font-size:11px;color:#000">2025:</span> {{(getTotalNew("all","margins","lastYear")/1000).toFixed(1)}}k€</div>
                </v-card-text>
                <v-card-text class="headline font-weight-bold text-center a-white" v-else>
                    <v-row no-gutters style="font-size:14px;">
                      <v-col cols="1"></v-col>
                      <v-col cols="4">
                        <div>Toteutuma</div>
                        <div><span style="font-size:10px;color:#000">2026:</span> {{(getTotalNew("all","margins","thisYear")/1000).toFixed(1)}}k€</div>
                        <div><span style="font-size:10px;color:#000">2025:</span> {{(getTotalNew("all","margins","lastYear")/1000).toFixed(1)}}k€</div>
                      </v-col>
                      <v-col cols="4">
                        <div>Tavoite</div>
                        <div>{{(getTotalNew("all","marginGoals","thisYear")/1000).toFixed(2)}}k€</div>
                        <!-- <div>{{(getTotalNew("all","marginGoals","lastYear")/1000).toFixed(2)}}k€</div> -->
                      </v-col>
                      <v-col cols="2">
                        <div>_</div>
                        <div style="color:orange;" v-if="getTotalNew('all','marginGoals','thisYear') > 0">{{((getTotalNew("all","margins","thisYear")/getTotalNew("all","marginGoals","thisYear"))*100).toFixed(1)}}%</div>
                        <div style="color:orange;" v-if="getTotalNew('all','marginGoals','lastYear') > 0">{{((getTotalNew("all","margins","lastYear")/getTotalNew("all","marginGoals","lastYear"))*100).toFixed(1)}}%</div>
                      </v-col>
                      <v-col cols="1"></v-col>
                    </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <!-- LASKUTETUT -->
            <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-title class="justify-center">
                  <v-icon small left>fas fa-file-invoice-dollar</v-icon>
                  <span class="font-weight-heavy">Vuoden laskutetut</span>
                </v-card-title>
                <v-card-text class="mt-3 headline font-weight-bold text-center a-white">
                  {{(getTotalNew("all","invoicedSales","thisYear")/1000).toFixed(1)}}k€
                </v-card-text>
              </v-card>
            </v-col>
            <!-- EI-LASKUTETUT -->
            <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-title class="justify-center">
                  <v-icon small left>fas fa-file-invoice-dollar</v-icon>
                  <span class="font-weight-heavy">Ei-laskutetut</span>
                </v-card-title>
                <v-card-text class="mt-3 headline font-weight-bold text-center a-white">
                  <!-- <div>Toteutuma</div> -->
                  <div><span style="font-size:10px;color:#000" class="pr-1">Myynti: </span>{{ (salespersonsBase['all']['totals']['nonInvoicedSales']/1000).toFixed(1) }}k€</div>
                  <div><span style="font-size:10px;color:#000" class="pr-1">Kate: </span>{{ (salespersonsBase['all']['totals']['nonInvoicedMargins']/1000).toFixed(1) }}k€</div>
                  <!-- <div><span style="font-size:10px;color:#000" class="pr-1">Myynti: </span>{{(getTotalNew("all","nonInvoicedSales","thisYear")/1000).toFixed(1)}}k€</div> -->
                  <!-- <div><span style="font-size:10px;color:#000" class="pr-1">Myynti: </span>{{(getTotalNew("all","nonInvoicedSales","lastYear")/1000).toFixed(1)}}k€</div> -->
                  
                </v-card-text>
              </v-card>
            </v-col>
            
            <!-- EI-MAKSETUT -->
            <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-title class="justify-center">
                  <v-icon small left>fas fa-file-invoice-dollar</v-icon>
                  <span class="font-weight-heavy">Netvisor maksamattomat</span>
                </v-card-title>
                <v-card-text class="mt-3 headline font-weight-bold text-center a-white">
                  <!-- {{ (salespersonsBase['all']['totals']['nonPaidInvoicedInvoices']/1000).toFixed(1) }}k€ -->
                  <div><span style="font-size:10px;color:#000" class="pr-1">Myynti: </span>{{ (salespersonsBase['all']['totals']['nonPaidInvoicedInvoices']/1000).toFixed(1) }}k€</div>
                  <div><span style="font-size:10px;color:#000" class="pr-1">Kate: </span>{{ (salespersonsBase['all']['totals']['nonPaidInvoicedInvoicesMargins']/1000).toFixed(1) }}k€</div>
                  <!-- {{(salespersonsBase['all']['totals']['nonPaidWithoutVat']/1000).toFixed(1)}}k€ -->
                    
                  <!-- {{(getTotalNew("all","nonPaidInvoicedInvoices","thisYear")/1000).toFixed(1)}}k€ -->
                </v-card-text>
              </v-card>
            </v-col>
            <!-- MAKSETUT -->
            <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-title class="justify-center">
                  <v-icon small left>fas fa-file-invoice-dollar</v-icon>
                  <span class="font-weight-heavy">Vuoden maksetut</span>
                </v-card-title>
                <v-card-text class="mt-3 headline font-weight-bold text-center a-white">
                  <!-- {{(getTotalNew("all","paymentsReceived","thisYear")/1000).toFixed(1)}}k€ -->
                  <div><span style="font-size:10px;color:#000" class="pr-1">Myynti: </span>{{(getTotalNew("all","paymentsReceived","thisYear")/1000).toFixed(1)}}k€</div>
                  <div><span style="font-size:10px;color:#000" class="pr-1">Kate: </span>{{(getTotalNew("all","paidInvoicedInvoicesMargins","thisYear")/1000).toFixed(1)}}k€</div>
                  <!-- <div><span style="font-size:10px;color:#000" class="pr-1">Kate: </span>{{ (salespersonsBase['all']['totals']['paidInvoicedInvoicesMargins']/1000).toFixed(1) }}k€</div> -->
                </v-card-text>
              </v-card>
            </v-col>
            <!-- ADMIN: KATEKERROIN -->
            <v-col v-if="staff[user.uid].isAdmin" :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-title class="justify-center">
                  <v-icon small left>fas fa-times</v-icon>
                  <span class="font-weight-heavy">Vuoden katekerroin</span>
                </v-card-title>
                <v-card-text class="mt-3 headline font-weight-bold text-center a-white">
                  {{getTotalNew("all","marginRate","thisYear").toFixed(2)}}
                </v-card-text>
              </v-card>
            </v-col>
            <!-- TILAUKSET -->
            <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-title class="justify-center">
                  <v-icon small left>fas fa-file-invoice-dollar</v-icon>
                  <span class="font-weight-heavy">Vuoden tilaukset</span>
                </v-card-title>
                <v-card-text class="mt-3 headline font-weight-bold text-center a-white">
                  {{getTotalNew("all","orders","thisYear")}}
                </v-card-text>
              </v-card>
            </v-col>
            <!-- UUDET ASIAKKAAT -->
            <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'"><!-- lg5-custom -->
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-title class="justify-center">
                  <v-icon small left>far fa-handshake</v-icon>
                  <span class="font-weight-heavy">Vuoden uudet asiakkaat</span>
                </v-card-title>
                <v-card-text class="mt-3 headline font-weight-bold text-center a-white">
                  {{getTotalNew("all","newCustomers","thisYear")}}
                </v-card-text>
              </v-card>
            </v-col>
            <!-- VARASTO TUOTTEIDEN OSUUS -->
            <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'"><!-- lg5-custom -->
              <v-card dark color="#191919" style="border-radius:0px;-webkit-box-shadow:unset;box-shadow:unset;background-color:#136DF5; ">
                <v-card-title class="justify-center">
                  <v-icon small left>fas fa-warehouse</v-icon>
                  <span class="font-weight-heavy">Varastotuotteiden osuus</span>
                </v-card-title>
                <v-card-text class="mt-3 headline font-weight-bold text-center a-white">
                  <div><span style="font-size:11px;color:#000">2026:</span> {{getTotalNew("all","warehouseProductSales","thisYear")}}%</div>
                  <div><span style="font-size:11px;color:#000">2025:</span> {{getTotalNew("all","warehouseProductSales","lastYear")}}%</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!-- </div>
          <div v-if="device === 'desktop'"> -->
          <v-lazy style="width:100%; padding:0px; margin:0px;min-height:150px" :options="{threshold: .1}">
            <div>
              <!--THIS YEAR-->
              <v-row no-gutters >
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Myynti 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'sales','months',2026), week:getChartData('all', 'sales','weeks',2026)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin"  :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Kate 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'margins','months',2026), week:getChartData('all', 'margins','weeks',2026)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin"  :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Laskutetut 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'invoicedSales','months',2026), week:getChartData('all', 'invoicedSales','weeks',2026)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin"  :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Laskuttamattomat 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'nonInvoicedSales','months',2026), week:getChartData('all', 'nonInvoicedSales','weeks',2026)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin"  :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Maksamattomat eräpäivän mukaan 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'nonPaidInvoicedInvoices','months',2026), week:getChartData('all', 'nonPaidInvoicedInvoices','weeks',2026)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin"  :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Maksetut 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'paymentsReceived','months',2026), week:getChartData('all', 'paymentsReceived','weeks',2026)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin"  :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Katekerroin 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'marginRate','months',2026), week:getChartData('all', 'marginRate','weeks',2026)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Tilaukset 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'orders','months',2026), week:getChartData('all', 'orders','weeks',2026)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Uudet asiakkaat 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'newCustomers','months',2026), week:getChartData('all', 'newCustomers','weeks',2026)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Varastuotteiden osuus 2026'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'warehouseProductSales','months',2026), week:getChartData('all', 'warehouseProductSales','weeks',2026)}" />
                </v-col>
              </v-row>
              <!--2025 YEAR-->
              <v-row no-gutters >
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Myynti 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'sales','months',2025), week:getChartData('all', 'sales','weeks',2025)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin" :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Kate 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'margins','months',2025), week:getChartData('all', 'margins','weeks',2025)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin" :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Katekerroin 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'marginRate','months',2025), week:getChartData('all', 'marginRate','weeks',2025)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Tilaukset 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'orders','months',2025), week:getChartData('all', 'orders','weeks',2025)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" :title="'Uudet asiakkaat 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'newCustomers','months',2025), week:getChartData('all', 'newCustomers','weeks',2025)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
                  <ReportChart type="bar" :title="'Varastuotteiden osuus 2025'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'warehouseProductSales','months',2025), week:getChartData('all', 'warehouseProductSales','weeks',2025)}" />
                </v-col>
              </v-row>
              <!--2020 YEAR-->
              <!-- <v-row v-if="staff[user.uid].isAdmin || staff[user.uid].role !== 'sales'" no-gutters >
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Myynti 2020'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'sales','months',2020), week:getChartData('all', 'sales','weeks',2020)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin" :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Kate 2020'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'margins','months',2020), week:getChartData('all', 'margins','weeks',2020)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin" :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Katekerroin 2020'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'marginRate','months',2020), week:getChartData('all', 'marginRate','weeks',2020)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" :title="'Tilaukset 2020'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'orders','months',2020), week:getChartData('all', 'orders','weeks',2020)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" :title="'Uudet asiakkaat 2020'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'newCustomers','months',2020), week:getChartData('all', 'newCustomers','weeks',2020)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
                  <ReportChart type="bar" :title="'Varastuotteiden osuus 2020'" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'warehouseProductSales','months',2020), week:getChartData('all', 'warehouseProductSales','weeks',2020)}" />
                </v-col>
              </v-row> -->
              <!--PER SALESPERSON-->
              <!--2026 YEAR-->
              <v-row no-gutters >
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" title="Myynti myyjittäin 2026" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'sales','months',2026,true), week:getChartData('all', 'sales','weeks',2026,true)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin" :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" title="Kate myyjittäin 2026" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'margins','months',2026,true), week:getChartData('all', 'margins','weeks',2026,true)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin" :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" title="Katekerroin myyjittäin 2026" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'marginRate','months',2026,true), week:getChartData('all', 'marginRate','weeks',2026,true)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" title="Tilaukset myyjittäin 2026" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'orders','months',2026,true), week:getChartData('all', 'orders','weeks',2026,true)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" title="Uudet asiakkaat myyjittäin 2026" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'newCustomers','months',2026,true), week:getChartData('all', 'newCustomers','weeks',2026,true)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
                  <ReportChart type="bar" title="Varastuotteiden osuus myyjittäin 2026" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'warehouseProductSales','months',2026,true), week:getChartData('all', 'warehouseProductSales','weeks',2026,true)}" />
                </v-col>
              </v-row>
              <!--2025 YEAR-->
              <v-row no-gutters >
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" title="Myynti myyjittäin 2025" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'sales','months',2025,true), week:getChartData('all', 'sales','weeks',2025,true)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin" :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" title="Kate myyjittäin 2025" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'margins','months',2025,true), week:getChartData('all', 'margins','weeks',2025,true)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin" :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" title="Katekerroin myyjittäin 2025" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'marginRate','months',2025,true), week:getChartData('all', 'marginRate','weeks',2025,true)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" title="Tilaukset myyjittäin 2025" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'orders','months',2025,true), week:getChartData('all', 'orders','weeks',2025,true)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" title="Uudet asiakkaat myyjittäin 2025" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'newCustomers','months',2025,true), week:getChartData('all', 'newCustomers','weeks',2025,true)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
                  <ReportChart type="bar" title="Varastuotteiden osuus myyjittäin 2025" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'warehouseProductSales','months',2025,true), week:getChartData('all', 'warehouseProductSales','weeks',2025,true)}" />
                </v-col>
              </v-row>
              <!--2020 YEAR-->
              <!-- <v-row v-if="staff[user.uid].isAdmin || staff[user.uid].role !== 'sales'" no-gutters >
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" title="Myynti myyjittäin 2020" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'sales','months',2020,true), week:getChartData('all', 'sales','weeks',2020,true)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin" :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" title="Kate myyjittäin 2020" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'margins','months',2020,true), week:getChartData('all', 'margins','weeks',2020,true)}" />
                </v-col>
                <v-col v-if="staff[user.uid].isAdmin" :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" title="Katekerroin myyjittäin 2020" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'marginRate','months',2020,true), week:getChartData('all', 'marginRate','weeks',2020,true)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                    <ReportChart type="bar" title="Tilaukset myyjittäin 2020" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'orders','months',2020,true), week:getChartData('all', 'orders','weeks',2020,true)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'" style="border-right:1px dotted #ccc; ">
                  <ReportChart type="bar" title="Uudet asiakkaat myyjittäin 2020" :options="{month:{dataLabels:{enabled:false},xaxis:{categories:months}}, week:{dataLabels:{enabled:false},xaxis:{categories:weeks}}}" :series="{month:getChartData('all', 'newCustomers','months',2020,true), week:getChartData('all', 'newCustomers','weeks',2020,true)}" />
                </v-col>
                <v-col :class="staff[user.uid].isAdmin ? 'col-sm-2' : 'col-3'">
                  
                </v-col>
              </v-row> -->
            </div>
          </v-lazy>
        </div>
      </div>
      
      <!-- TOP TUOTTEET JA ASIAKKAAT -->
      <div v-if="selectedReportTab === 'top'" class="no-scrollbars" style="height:100%;overflow-y:scroll;padding-bottom:300px;">
        <v-row no-gutters >
          <v-col cols="7" ><!-- style="border-bottom:1px solid #ccc;" -->
            <v-row no-gutters>
              <v-col cols="2" class="px-2">
                <v-autocomplete
                  style=""
                  label="Tuote / Tuotevariaatio"
                  v-model="productOrPvFilterForProducts"
                  :items="[{text:'Tuote',value:'product'},{text:'Tuotevariaatio',value:'productVariation'}]"
                  outlined
                  dense
                  item-text="text"
                  item-value="value"
                  class="avecor-select hide-field-details text-right mt-4"
                />
              </v-col>
              <v-col cols="2" class="px-2">
                <v-autocomplete
                  style=""
                  label="Myyjä"
                  :value="salespersonFilterForProducts"
                  @change="v => salespersonFilterForProducts = v"
                  :items="getSalespersonsForFilter()"
                  outlined
                  dense
                  item-text="firstName"
                  item-value="id"
                  class="avecor-select hide-field-details text-right mt-4"
                />
              </v-col>
              <v-col cols="4" class="px-2">
                <v-autocomplete
                  style=""
                  label="Toimiala"
                  :value="industryFilterForProducts"
                  @change="v => industryFilterForProducts = v"
                  :items="getIndustries"
                  outlined
                  dense
                  item-text="fi"
                  item-value="id"
                  class="avecor-select hide-field-details text-right pl-2 mt-4"
                />
              </v-col>
              <v-col cols="4" class="px-2" >
                <v-autocomplete
                  style=""
                  label="Kuukausi"
                  :value="monthFilterForProducts"
                  @change="v => monthFilterForProducts = v"
                  :items="getMonthsForFilter()"
                  outlined
                  dense
                  item-text="month"
                  item-value="id"
                  class="avecor-select hide-field-details text-right mt-4"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="5" class="px-2" style="border-left:1px dotted #ccc; " ><!--  -->
            <v-autocomplete
              style=""
              v-if="allAccess"
              label="Myyjä"
              :value="salespersonFilterForCompanies"
              @change="v => salespersonFilterForCompanies = v"
              :items="getSalespersonsForFilter()"
              outlined
              dense
              item-text="firstName"
              item-value="id"
              class="avecor-select hide-field-details text-right mt-4"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="7">
            <v-row no-gutters>
              <v-col cols="6" >
                <ReportTable label="Kuluvan vuoden top tuotteet" field="name" split="productVariations" :data="getTableData('thisYear','sales', 'productVariations')"></ReportTable>
              </v-col>

              <v-col cols="6" style="border-left:1px dotted #ccc; ">
                <ReportTable label="Viime vuoden top tuotteet" field="name" split="productVariations" :data="getTableData('lastYear','sales', 'productVariations')"></ReportTable>
              </v-col>
              
            </v-row>
          </v-col>
          <v-col cols="5" style="border-left:1px dotted #ccc; ">
            <v-row no-gutters>
              <v-col cols="6" >
                <ReportTable label="Kuluvan vuoden top asiakkaat" field="name" split="companies" :data="getTableData('thisYear','sales','companies')"></ReportTable>
              </v-col>
              <v-col cols="6" style="border-left:1px dotted #ccc; ">
                <ReportTable label="Viime vuoden top asiakkaat" field="name" split="companies" :data="getTableData('lastYear','sales','companies')"></ReportTable>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <!-- SCORECARD -->
      <div v-if="selectedReportTab === 'competition'" class="no-scrollbars" style="height:100%;overflow-y:scroll;padding-bottom:300px;">
          <v-btn v-if="allAccess" style="position:absolute;top:40px; right:10px" color="#000000" @click="addCompetition"  dark class="avecor-button-global add-button mr-3">Lisää kilpailu</v-btn>
          <v-row no-gutters fill-height v-if="device === 'desktop'">
            <v-col :cols="getCompetitions.length > 1 ? 6 :12" v-for="c in getCompetitions" :key="c.id">
              <ReportCompetition label="Kilpailu X" split="salespersons" :details="c" :productNames="getProductVariationNames(c.products)" :data="getTableDataForCompetition(c.id)"></ReportCompetition>
            </v-col>
          </v-row>


      </div>

      <!-- SCORECARD -->
      <div v-if="selectedReportTab === 'scorecard'" class="no-scrollbars" style="height:100%;overflow-y:scroll;padding-bottom:300px;">
        <!-- SCORECARD: MOBILE -->
        <div v-if="device === 'mobile'" class="fill-height">
          <v-row no-gutters>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan viikon myynti" split="salespersons" :data="getTableData('thisWeek','sales','salespersons')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime viikon myynti" :data="getTableData('lastWeek','sales','salespersons')"></ReportTable>
            </v-col>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan kuukauden myynti" :data="getTableData('thisMonth','sales','salespersons')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime kuukauden myynti" :data="getTableData('lastMonth','sales','salespersons')"></ReportTable>
            </v-col>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan vuoden myynti" :data="getTableData('thisYear','sales','salespersons')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable v-if="staff[user.uid].isAdmin || staff[user.uid].role !== 'sales'" label="Viime vuoden myynti" :data="getTableData('lastYear','sales','salespersons')"></ReportTable>
            </v-col>
          </v-row>
          <v-row no-gutters v-if="staff[user.uid].isAdmin || staff[user.uid].role !== 'sales'">
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan viikon kate" :data="getTableData('thisWeek','margins')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime viikon kate" :data="getTableData('lastWeek','margins')"></ReportTable>
            </v-col>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan kuukauden kate" :data="getTableData('thisMonth','margins')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime kuukauden kate" :data="getTableData('lastMonth','margins')"></ReportTable>
            </v-col>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan vuoden kate" :data="getTableData('thisYear','margins')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime vuoden kate" :data="getTableData('lastYear','margins')"></ReportTable>
            </v-col>
          </v-row>
          <v-row no-gutters v-if="staff[user.uid].isAdmin || staff[user.uid].role !== 'sales'">
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan viikon katekerroin" :data="getTableData('thisWeek','marginRate')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime viikon katekerroin" :data="getTableData('lastWeek','marginRate')"></ReportTable>
            </v-col>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan kuukauden katekerroin" :data="getTableData('thisMonth','marginRate')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime kuukauden katekerroin" :data="getTableData('lastMonth','marginRate')"></ReportTable>
            </v-col>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan vuoden katekerroin" :data="getTableData('thisYear','marginRate')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime vuoden katekerroin" :data="getTableData('lastYear','marginRate')"></ReportTable>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan viikon kaupat" :data="getTableData('thisWeek','orders')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime viikon kaupat" :data="getTableData('lastWeek','orders')"></ReportTable>
            </v-col>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan kuukauden kaupat" :data="getTableData('thisMonth','orders')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime kuukauden kaupat" :data="getTableData('lastMonth','orders')"></ReportTable>
            </v-col>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan vuoden kaupat" :data="getTableData('thisYear','orders')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime vuoden kaupat" :data="getTableData('lastYear','orders')"></ReportTable>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan viikon uudet asiakkaat" :data="getTableData('thisWeek','newCustomers')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime viikon uudet asiakkaat" :data="getTableData('lastWeek','newCustomers')"></ReportTable>
            </v-col>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan kuukauden uudet asiakkaat" :data="getTableData('thisMonth','newCustomers')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable label="Viime kuukauden uudet asiakkaat" :data="getTableData('lastMonth','newCustomers')"></ReportTable>
            </v-col>
            <v-col cols="6" style="border-left:1px dotted #ccc; ">
              <ReportTable label="Kuluvan vuoden uudet asiakkaat" :data="getTableData('thisYear','newCustomers')"></ReportTable>
            </v-col>
            <v-col cols="6">
              <ReportTable v-if="staff[user.uid].isAdmin || staff[user.uid].role !== 'sales'" label="Viime vuoden uudet asiakkaat" :data="getTableData('lastYear','newCustomers')"></ReportTable>
            </v-col>
          </v-row>
        </div>

        <!-- SCORECARD: DESKTOP -->
        <v-row no-gutters fill-height v-if="device === 'desktop'">
          <v-col cols="2" style="border-left:1px dotted #ccc; " :class="getColsForTable">
            <v-row no-gutters >
              <ReportTable label="Kuluvan viikon myynti" split="salespersons" :data="getTableData('thisWeek','sales','salespersons')"></ReportTable>
            </v-row>  
            <v-row no-gutters>
              <ReportTable label="Viime viikon myynti" split="salespersons" :data="getTableData('lastWeek','sales','salespersons')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Kuluvan kuukauden myynti" split="salespersons" :data="getTableData('thisMonth','sales','salespersons')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Viime kuukauden myynti" split="salespersons" :data="getTableData('lastMonth','sales','salespersons')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Kuluvan vuoden myynti" split="salespersons" :data="getTableData('thisYear','sales','salespersons')"></ReportTable>
            </v-row>
            <v-row no-gutters v-if="allAccess">
              <ReportTable label="Viime vuoden myynti" split="salespersons" :data="getTableData('lastYear','sales','salespersons')"></ReportTable>
            </v-row>
          </v-col>
          <v-col v-if="allAccess" style="border-left:1px dotted #ccc; " :class="getColsForTable">
            <v-row no-gutters>
              <ReportTable label="Kuluvan viikon kate" split="salespersons" :data="getTableData('thisWeek','margins')"></ReportTable>
            </v-row>  
            <v-row no-gutters>
              <ReportTable label="Viime viikon kate" split="salespersons" :data="getTableData('lastWeek','margins')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Kuluvan kuukauden kate" split="salespersons" :data="getTableData('thisMonth','margins')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Viime kuukauden kate" split="salespersons" :data="getTableData('lastMonth','margins')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Kuluvan vuoden kate" split="salespersons" :data="getTableData('thisYear','margins')"></ReportTable>
            </v-row>
            <v-row no-gutters v-if="allAccess">
              <ReportTable label="Viime vuoden kate" split="salespersons" :data="getTableData('lastYear','margins')"></ReportTable>
            </v-row>
          </v-col>
          <v-col style="border-left:1px dotted #ccc; " :class="getColsForTable">
            <v-row no-gutters>
              <ReportTable label="Kuluvan viikon katekerroin" split="salespersons" :data="getTableData('thisWeek','marginRate')"></ReportTable>
            </v-row>  
            <v-row no-gutters>
              <ReportTable label="Viime viikon katekerroin" split="salespersons" :data="getTableData('lastWeek','marginRate')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Kuluvan kuukauden katekerroin" split="salespersons" :data="getTableData('thisMonth','marginRate')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Viime kuukauden katekerroin" split="salespersons" :data="getTableData('lastMonth','marginRate')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Kuluvan vuoden katekerroin" split="salespersons" :data="getTableData('thisYear','marginRate')"></ReportTable>
            </v-row>
            <v-row no-gutters v-if="allAccess">
              <ReportTable label="Viime vuoden katekerroin" split="salespersons" :data="getTableData('lastYear','marginRate')"></ReportTable>
            </v-row>
          </v-col>
          <v-col style="border-left:1px dotted #ccc; " :class="getColsForTable">
            <v-row no-gutters>
              <ReportTable label="Kuluvan viikon kaupat" split="salespersons" :data="getTableData('thisWeek','orders')"></ReportTable>
            </v-row>  
            <v-row no-gutters>
              <ReportTable label="Viime viikon kaupat" split="salespersons" :data="getTableData('lastWeek','orders')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Kuluvan kuukauden kaupat" split="salespersons" :data="getTableData('thisMonth','orders')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Viime kuukauden kaupat" split="salespersons" :data="getTableData('lastMonth','orders')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Kuluvan vuoden kaupat" split="salespersons" :data="getTableData('thisYear','orders')"></ReportTable>
            </v-row>
            <v-row no-gutters v-if="allAccess">
              <ReportTable label="Viime vuoden kaupat" split="salespersons" :data="getTableData('lastYear','orders')"></ReportTable>
            </v-row>
          </v-col>
          <v-col style="border-left:1px dotted #ccc; " :class="getColsForTable">
            <v-row no-gutters>
              <ReportTable label="Kuluvan viikon uudet asiakkaat" split="salespersons" :data="getTableData('thisWeek','newCustomers')"></ReportTable>
            </v-row>  
            <v-row no-gutters>
              <ReportTable label="Viime viikon uudet asiakkaat" split="salespersons" :data="getTableData('lastWeek','newCustomers')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Kuluvan kuukauden uudet asiakkaat" split="salespersons" :data="getTableData('thisMonth','newCustomers')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Viime kuukauden uudet asiakkaat" split="salespersons" :data="getTableData('lastMonth','newCustomers')"></ReportTable>
            </v-row>
            <v-row no-gutters>
              <ReportTable label="Kuluvan vuoden uudet asiakkaat" split="salespersons" :data="getTableData('thisYear','newCustomers')"></ReportTable>
            </v-row>
            <v-row no-gutters v-if="allAccess">
              <ReportTable label="Viime vuoden uudet asiakkaat" split="salespersons" :data="getTableData('lastYear','newCustomers')"></ReportTable>
            </v-row>
          </v-col>
          <v-col v-if="shouldSeeWeeklyReportNumbers" style="border-left:1px dotted #ccc; " :class="getColsForTable">
            <v-row no-gutters ><!--  -->
              <ReportTable label="Kuluvan viikon tapaamiset" split="salespersons" :data="getTableData('thisWeek','agreedVisits')"></ReportTable>
            </v-row>  
            <v-row no-gutters ><!-- style="min-height:680px;" -->
              <ReportTable label="Viime viikon tapaamiset" split="salespersons" :data="getTableData('lastWeek','agreedVisits')"></ReportTable>
            </v-row>
            <v-row no-gutters ><!-- style="min-height:690px;" -->
              <ReportTable label="Kuluvan kuukauden tapaamiset" split="salespersons" :data="getTableData('thisMonth','agreedVisits')"></ReportTable>
            </v-row>
            <v-row no-gutters ><!-- style="min-height:690px;" -->
              <ReportTable label="Viime kuukauden tapaamiset" split="salespersons" :data="getTableData('lastMonth','agreedVisits')"></ReportTable>
            </v-row>
            <v-row no-gutters ><!-- style="min-height:690px;" -->
              <ReportTable label="Kuluvan vuoden tapaamiset" split="salespersons" :data="getTableData('thisYear','agreedVisits')"></ReportTable>
            </v-row>
            <v-row no-gutters v-if="allAccess">
              <ReportTable label="Viime vuoden tapaamiset" split="salespersons" :data="getTableData('lastYear','agreedVisits')"></ReportTable>
            </v-row>
          </v-col>
        </v-row>
        
      </div>
    </div>
    <AddCompetition />
  </v-container>  
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import ReportTable from './../blocks/ReportTable'
import ReportCompetition from './../blocks/ReportCompetition'
import AddCompetition from './../blocks/AddCompetition'
import ReportChart from './../blocks/ReportChart'
import shared from './../../shared'
import firebase from 'firebase'

var db = null


export default {
    components: {
      ReportTable,
      ReportChart,
      ReportCompetition,
      AddCompetition
    },
    created(){
      this.createVariationName = shared.createVariationName
    },
    data () {
      return {
        //width:this.$vuetify.breakpoint.width,
        productOrPvFilterForProducts:'product',
        competitionsMap:{},
        selectedUid:'',
        salespersonFilterForCompanies:null,
        salespersonFilterForProducts:null,
        monthFilterForProducts: 'all',
        industryFilterForProducts:'all',
        windowWidth: window.innerWidth,
        device: window.innerWidth <= 800 ? 'mobile' : 'desktop',
        selectedReportTab:'salesperson',//'competition','company','salesperson'
        largeChartFigures:null,
        largeChartVisible:false,
        largeChartTitle:"",
        years:[2022,2023,2024,2025,2026],
        months:[1,2,3,4,5,6,7,8,9,10,11,12],
        weeks:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53],
        metrics:['sales','orders','margins','marginRate','newCustomers','agreedVisits','warehouseProductSales'],
        goals:['salesGoals','marginRateGoals','marginGoals'],
        salespersonsBase:{},
        productVariationsBase:{},
        productsBase:{},
        companiesBase:{},
        competitionsBase:{},
        dataSetup:false
      }
    },
    async mounted() {
      this.selectedUid = this.user.uid
      db = firebase.firestore();
      await this.initiateCompetitions()
      if(!this.allAccess) {
        this.salespersonFilterForCompanies = this.user.uid
        this.salespersonFilterForProducts = this.user.uid
      }
      else {
        this.salespersonFilterForCompanies = 'all'
        this.salespersonFilterForProducts = 'all'
      }
      this.generateCBaseData()
      this.generateCompetitionActualData()
      this.generateBaseData()
      //this.set2019Numbers()
      var loadDataRenderedOnServer = true
      if(loadDataRenderedOnServer){
        this.loadSalespersonsBase()
      }
      else{
        this.generateActualData()
      }
            
      //this.generateActualDataForAgreedVisits()
      this.dataSetup = true
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
      })
      
    },
    computed: {
      getIndustries(){
        var industries = []
        industries.push({id:"all",fi:"Kaikki"})
        var industriesFromSettings = Object.entries(this.settings.industries).map(i => {return i[1] } )
        industries = [...industries,...industriesFromSettings]
        return industries
      },
      getCompetitions(){
        var t = this
        var competitions = []
        Object.keys(this.competitionsMap).forEach(cId => {
          competitions.push(this.competitionsMap[cId])
        })
        return competitions
      },
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office')
      },
      shouldSeeWeeklyReportNumbers(){
        if(this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role === 'office') return true
        else if(this.staff[this.user.uid].weekReportingRequired) return true
        else return false
      },
      getColsForTable(){
        // use lg5-custom for 5 colums
        if(this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role === 'office') return 'col-2'
        else if(this.staff[this.user.uid].weekReportingRequired) return 'lg5-custom'
        else return 'col-3'
         
      },
      formTitle () {
      },
      ...mapFields({
        clientNameTags:'clientNameTags',
        staff:'staff.staff',
        settings:'settings',
        signInLoader:'settings.signInLoader',
        user:'user',
        products:'product.products',
        productVariations:'productVariation.productVariations',
        orders:"order.orders",
        orderedProducts:'orderedProduct.orderedProducts',
        companies:"company.companies",
        newCompetitionModalVisible:"modals.report.competition.new.visible",
        newCompetitionModalData:"modals.report.competition.new.data",
      }),
    },
    watch: {
      competitionsMap: {
        handler(val){
          this.generateCBaseData()
          this.generateCompetitionActualData()
        },
        deep:true
      },
      selectedReportTab:{
        handler(val){
          console.log(val)
          if(val === 'top') this.loadCompaniesAndProductVariationsBase()
        },
      }
    },
    methods: {
      saveReportBase() {
        console.log(this.competitionsBase)
        Object.keys(this.competitionsBase).forEach(id => {
          var row = this.competitionsBase[id]
          const size = new TextEncoder().encode(JSON.stringify(row)).length
          const kiloBytes = size / 1024;  
          console.log(id,kiloBytes)
          var data = JSON.stringify(row)
          db.collection('reportCompetitionsData').doc(id).set({data})
        })

        Object.keys(this.salespersonsBase).forEach(id => {
          var row = this.salespersonsBase[id]
          const size = new TextEncoder().encode(JSON.stringify(row)).length
          const kiloBytes = size / 1024;  
          console.log(id,kiloBytes)
          var data = JSON.stringify(row)
          db.collection('reportSalespersonsData').doc(id).set({data})
        })
        /* Object.keys(this.companiesBase).forEach(id => {
          var row = this.companiesBase[id]
          const size = new TextEncoder().encode(JSON.stringify(row)).length
          const kiloBytes = size / 1024;  
          console.log(id,kiloBytes)
          var data = JSON.stringify(row)
          db.collection('reportCompaniesData').doc(id).set({data})
        }) */
        /* Object.keys(this.productVariationsBase).forEach(id => {
          var row = this.productVariationsBase[id]
          const size = new TextEncoder().encode(JSON.stringify(row)).length
          const kiloBytes = size / 1024;  
          console.log(id,kiloBytes)
          var data = JSON.stringify(row)
          db.collection('reportProductVariationsData').doc(id).set({data})
        }) */
      },
      async loadSalespersonsBase(){
        var salespersonsBase = {}
        /* const snapshot = await db.collection("reportSalespersonsData").get()
        for(var i = 0; i < snapshot.docs.length;i++){
          var doc = snapshot.docs[i]
          var data = doc.data()
          console.log(data)
          salespersonsBase[doc.id] = JSON.parse(data.data)
        }
        this.salespersonsBase = salespersonsBase */
        var t = this

        db.collection("reportSalespersonsData").onSnapshot(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              //var doc = snapshot.docs[i]
              var data = doc.data()
              //console.log(data)
              salespersonsBase[doc.id] = JSON.parse(data.data)
            });
            console.log(salespersonsBase['all'])
            t.salespersonsBase = salespersonsBase
            t.generateActualDataForAgreedVisits()
        })

      },
      async loadCompaniesAndProductVariationsBase(){
        this.companiesBase = {}
        this.productVariationsBase = {}
        this.productsBase = {}
        
        var companiesBase = {}
        var productVariationsBase = {}
        var productsBase = {}

        const reportCompaniesSnapshot = await db.collection("reportCompaniesData").get()
        for(var i = 0; i < reportCompaniesSnapshot.docs.length;i++){
          var doc = reportCompaniesSnapshot.docs[i]
          var data = doc.data()
          companiesBase[doc.id] = JSON.parse(data.data)
        }
        const reportProductVariationsSnapshot = await db.collection("reportProductVariationsData").get()
        for(var i = 0; i < reportProductVariationsSnapshot.docs.length;i++){
          var doc = reportProductVariationsSnapshot.docs[i]
          var data = doc.data()
          productVariationsBase[doc.id] = JSON.parse(data.data)
        }
        const reportProductsSnapshot = await db.collection("reportProductsData").get()
        for(var i = 0; i < reportProductsSnapshot.docs.length;i++){
          var doc = reportProductsSnapshot.docs[i]
          var data = doc.data()
          productsBase[doc.id] = JSON.parse(data.data)
        }
        this.companiesBase = companiesBase
        this.productVariationsBase = productVariationsBase
        this.productsBase = productsBase
      },

      getProductVariationNames(ids){
        var names = []
        ids.forEach(pvId => {
          if(this.productVariationsBase && this.productVariationsBase['all'] && this.productVariationsBase['all'][pvId] && this.productVariationsBase['all'][pvId].name)  names.push(this.productVariationsBase['all'][pvId].name)
        })
        return names
      },
      addCompetition(){
        this.newCompetitionModalData = null
        this.newCompetitionModalVisible = true
      },
      initiateCompetitions(){
        var t = this
        return new Promise(async function(resolve, reject) {
          try {
            db.collection("competitions").onSnapshot(function(querySnapshot) {
                var competitionsMap = {}
                querySnapshot.forEach(function(doc) {
                    competitionsMap[doc.id] = {...doc.data(),id:doc.id}
                });
                t.competitionsMap = competitionsMap
                 //t.createCompetitionsArray()
                resolve("ok")  
            })
          }
          catch (e){
            reject(e)
          }
        });
      },
      onResize() {
        if(window.innerWidth <= 800) this.device = 'mobile'
        else this.device = 'desktop'
        //this.windowWidth = window.innerWidth
      },
      getSalespersonsForFilter(){
        var staff = this.staff
        var salespersons = []
        salespersons.push({id:'all',firstName:'--Kaikki--' })
        for (const key in this.staff){
          if(this.staff[key].role === 'sales' && !this.staff[key].isExit) {
            salespersons.push({id:key,firstName:this.staff[key].firstName, })
          }
        }
        return salespersons
      },
      getMonthsForFilter(){
        var staff = this.staff
        var months = []
        months.push({id:'all',month:'--Kaikki--' })
        for (var i = 1; i < 13; i++){
          months.push({id:i,month:i })
        }
        return months
      },
      getSalespersons(){
        var staff = this.staff
        var salespersons = []
        for (const key in this.staff){
          if(this.staff[key].role === 'sales' && !this.staff[key].isExit) {
            salespersons.push({
              id:key,
              firstName:this.staff[key].firstName, 
              weekReportingRequired:this.staff[key].weekReportingRequired !== undefined ? this.staff[key].weekReportingRequired : false
            })
          }
        }
        return salespersons
      },
      getAllSalespersons(){
        var salespersons = []
        for (const key in this.staff){
          
          if(this.staff[key].role === 'sales') salespersons.push({firstName:this.staff[key].firstName, id:key})
        }
        return salespersons
      },
      getAllActiveSalespersons(){
        var salespersons = []
        for (const key in this.staff){
          if(this.staff[key].role === 'sales' && !this.staff[key].isExit) salespersons.push({firstName:this.staff[key].firstName, id:key})
        }
        return salespersons
      },
      generateCBaseData(){
        var competitionsBase = {}
        this.getCompetitions.forEach(c =>{
          competitionsBase[c.id] = {}
          competitionsBase[c.id]['all'] = { 
            firstName:'Kaikki', 
            goal:c.salespersons && c.salespersons['all'] ? c.salespersons['all'].goal : 0,
            result:0, 
            previousYearResult:0 
          }
          this.getAllActiveSalespersons().forEach(salesperson => {
            competitionsBase[c.id][salesperson.id] = { 
              firstName:salesperson.firstName, 
              goal:c.salespersons && c.salespersons[salesperson.id] ? c.salespersons[salesperson.id].goal : 0,
              result:0, 
              previousYearResult:0 
            }
          })
        })
        this.competitionsBase = competitionsBase
      },
      generateBaseData(){
        var salespersonsBase = {}
        this.getAllSalespersons().forEach(salesperson => {
          salespersonsBase[salesperson.id] = {}
          this.years.forEach(year => {
            salespersonsBase[salesperson.id][year] = {}
            salespersonsBase[salesperson.id][year]["months"] = {}
            salespersonsBase[salesperson.id][year]["weeks"] = {}
            salespersonsBase[salesperson.id][year]["year"] = {}
            this.metrics.forEach(metric => {
              salespersonsBase[salesperson.id][year]["year"][metric] = 0
            })
            this.goals.forEach(goal => {
              salespersonsBase[salesperson.id][year]["year"][goal] = 0
            })
            this.months.forEach(month => {
              salespersonsBase[salesperson.id][year]["months"][month] = {}
              this.metrics.forEach(metric => {
                salespersonsBase[salesperson.id][year]["months"][month][metric] = 0
              })
              this.goals.forEach(goal => {
                salespersonsBase[salesperson.id][year]["months"][month][goal] = 0
              })
            })
            this.weeks.forEach(week => {
              salespersonsBase[salesperson.id][year]["weeks"][week] = {}
              this.metrics.forEach(metric => {
                salespersonsBase[salesperson.id][year]["weeks"][week][metric] = 0
              })
            })
          })
        });
        salespersonsBase["all"] = {}
        this.years.forEach(year => {
          salespersonsBase["all"][year] = {}
          salespersonsBase["all"][year]["months"] = {}
          salespersonsBase["all"][year]["weeks"] = {}
          salespersonsBase["all"][year]["year"] = {}
          this.metrics.forEach(metric => {
              salespersonsBase["all"][year]["year"][metric] = 0
          })
          this.goals.forEach(goal => {
              salespersonsBase["all"][year]["year"][goal] = 0
          })
          this.months.forEach(month => {
            salespersonsBase["all"][year]["months"][month] = {}
            this.metrics.forEach(metric => {
              salespersonsBase["all"][year]["months"][month][metric] = 0
            })
            this.goals.forEach(goal => {
              salespersonsBase["all"][year]["months"][month][goal] = 0
            })
          })
          this.weeks.forEach(week => {
            salespersonsBase["all"][year]["weeks"][week] = {}
            this.metrics.forEach(metric => {
              salespersonsBase["all"][year]["weeks"][week][metric] = 0
            })
          })
        })
        this.salespersonsBase = salespersonsBase
      },

      getTotalNew(salesperson, metric,timeFrame) {
        var year = null
        if(timeFrame === "thisYear") {year = new Date().getFullYear()}
        else if(timeFrame === "lastYear") {year = new Date().getFullYear() - 1}

        if(metric === 'warehouseProductSales'){
          var share = 0
          if(this.salespersonsBase[salesperson] && this.salespersonsBase[salesperson][year] && this.salespersonsBase[salesperson][year]["year"] && this.salespersonsBase[salesperson][year]["year"]['sales'] && this.salespersonsBase[salesperson][year]["year"]['warehouseProductSales']){
            share = Number(this.salespersonsBase[salesperson][year]["year"]['warehouseProductSales'])/Number(this.salespersonsBase[salesperson][year]["year"]['sales'])
            share = share * 100
            share = share.toFixed(2)
          }
          return share
        }

        if (this.salespersonsBase[salesperson] === undefined || this.salespersonsBase[salesperson][year] === undefined) return 0
        //if(!this.salespersonsBase[salesperson][year]) console.log(this.salespersonsBase[salesperson])
        return this.salespersonsBase[salesperson][year]["year"][metric]
      },
      getTableDataForCompetition(cId){
        if(!this.competitionsBase[cId]) return []
        var table = []
        Object.keys(this.competitionsBase[cId]).forEach(spId => {
          var d = this.competitionsBase[cId][spId]
          table.push({
            salespersonId:spId, 
            firstName:d.firstName, 
            goal:d.goal, 
            result:d.result,
            previousYearResult:d.previousYearResult
          })
        })
        return table
      },
      getTableData(timeFrame,metric,split){
        // getTableData('thisWeek','sales','salespersons')
        var table = []
        if(!this.dataSetup) return table
        var year = null
        var week = null
        var month = null
        year = new Date().getFullYear()
        var products = this.products
        var productVariations = this.productVariations
        var salespersons = []
        if(metric === 'agreedVisits') { 
          Object.keys(this.staff).forEach(id =>{
            if(this.staff[id].weekReportingRequired && !this.staff[id].isExit) salespersons.push({id,firstName:this.staff[id].firstName})
          })
        }
        else salespersons = this.getSalespersons()
        if(split === 'companies' || split === 'productVariations'){
          var base = ''
          if (split === 'companies') base = this.companiesBase
          else if (split === 'productVariations') {
            if(this.productOrPvFilterForProducts === 'product') base = this.productsBase
            else if(this.productOrPvFilterForProducts === 'productVariation') base = this.productVariationsBase
            console.log(this.productOrPvFilterForProducts)
          }
          
          if (!base) return
          if (metric !== 'sales') return table
          if (timeFrame === "thisYear" || timeFrame === "lastYear") {
            year = timeFrame === "lastYear" ? year - 1 : year
            var filter = null
            var monthFilter = null
            var industryFilter = 'all'
            if (split === 'productVariations') filter = this.salespersonFilterForProducts
            if (split === 'productVariations') monthFilter = this.monthFilterForProducts
            if (split === 'productVariations') industryFilter = this.industryFilterForProducts
            
            else filter = this.salespersonFilterForCompanies
            if(base[filter]){
              Object.keys(base[filter]).forEach(id => {
                if(base[filter][id][year] && base[filter][id][year]["year"] && base[filter][id][year]["year"][metric]){
                  if(split === 'companies') {
                    table.push({
                      name:base[filter][id].name, 
                      salespersonId:base[filter][id].salespersonId, 
                      salespersonName:base[filter][id].salespersonName, 
                      total:base[filter][id][year]["year"][metric]
                    })
                    //console.log(filter, id, base[filter][id].salespersonId)
                  }
                  else if(split === 'productVariations') {
                    var sku = ''
                    var isMarginCalculationActivated = false
                    if(this.productOrPvFilterForProducts === 'product') {
                      sku = products[id] ? ' (' + products[id].avecorSku + ')' :''
                      isMarginCalculationActivated = products[id] && products[id].isMarginCalculationActivated ? true : false
                    }
                    else if(this.productOrPvFilterForProducts === 'productVariation') {
                      sku = productVariations[id] ? ' (' + products[productVariations[id].productId].avecorSku + ')' :''
                      isMarginCalculationActivated = productVariations[id] && products[productVariations[id].productId] && products[productVariations[id].productId].isMarginCalculationActivated ? true : false
                    }
                    
                    if(monthFilter === 'all'){
                      if(industryFilter === 'all'){
                        table.push({
                          name:base[filter][id].name + sku, 
                          numberOfProducts:base[filter][id][year]["year"]['numberOfProducts'], 
                          numberOfOrders:base[filter][id][year]["year"]['numberOfOrders'], 
                          avgMarg:base[filter][id][year]["year"]['avgMarg'], 
                          total:base[filter][id][year]["year"][metric],
                          averagePrice:(Number(base[filter][id][year]["year"][metric])/Number(base[filter][id][year]["year"]['numberOfProducts'])).toFixed(2),
                          isMarginCalculationActivated
                        })
                      }
                      else if(base[filter][id][year]["year"]["industries"] && base[filter][id][year]["year"]["industries"][industryFilter]) {
                        table.push({
                          name:base[filter][id].name + sku, 
                          numberOfProducts:base[filter][id][year]["year"]["industries"][industryFilter]['numberOfProducts'], 
                          numberOfOrders:base[filter][id][year]["year"]["industries"][industryFilter]['numberOfOrders'], 
                          total:base[filter][id][year]["year"]["industries"][industryFilter][metric],
                          averagePrice:(Number(base[filter][id][year]["year"]["industries"][industryFilter][metric])/Number(base[filter][id][year]["year"]["industries"][industryFilter]['numberOfProducts'])).toFixed(2),
                          isMarginCalculationActivated
                        })
                      }
                    }
                    else {
                      if(base[filter][id][year]["year"]['months'] && base[filter][id][year]["year"]['months'][monthFilter]){
                        if(industryFilter === 'all'){
                          console.log("HERE")
                          var numberOfProducts = base[filter][id][year]["year"]['months'][monthFilter]['numberOfProducts'] ? base[filter][id][year]["year"]['months'][monthFilter]['numberOfProducts'] : 0
                          var numberOfOrders = base[filter][id][year]["year"]['months'][monthFilter]['numberOfOrders'] ? base[filter][id][year]["year"]['months'][monthFilter]['numberOfOrders'] : 0
                          var avgMarg = base[filter][id][year]["year"]['months'][monthFilter]['avgMarg'] ? base[filter][id][year]["year"]['months'][monthFilter]['avgMarg'] : 0
                          var total = base[filter][id][year]["year"]['months'][monthFilter][metric] ? base[filter][id][year]["year"]['months'][monthFilter][metric] : 0
                          var averagePrice = 0
                          if(numberOfProducts && total) averagePrice = (Number(total)/Number(numberOfProducts)).toFixed(2)
                          table.push({
                            name:base[filter][id].name + sku,
                            numberOfProducts,
                            numberOfOrders,
                            avgMarg,
                            total:total.toFixed(2),
                            averagePrice,
                            isMarginCalculationActivated
                          })
                        }
                        else if(base[filter][id][year]["year"]["months"][monthFilter]["industries"] && base[filter][id][year]["year"]["months"][monthFilter]["industries"][industryFilter]) {
                          var numberOfProducts = base[filter][id][year]["year"]['months'][monthFilter]["industries"][industryFilter]['numberOfProducts'] ? base[filter][id][year]["year"]['months'][monthFilter]["industries"][industryFilter]['numberOfProducts'] : 0
                          var numberOfOrders = base[filter][id][year]["year"]['months'][monthFilter]["industries"][industryFilter]['numberOfOrders'] ? base[filter][id][year]["year"]['months'][monthFilter]["industries"][industryFilter]['numberOfOrders'] : 0
                          var total = base[filter][id][year]["year"]['months'][monthFilter]["industries"][industryFilter][metric] ? base[filter][id][year]["year"]['months'][monthFilter]["industries"][industryFilter][metric] : 0
                          var averagePrice = 0
                          if(numberOfProducts && total) averagePrice = (Number(total)/Number(numberOfProducts)).toFixed(2)
                          table.push({
                            name:base[filter][id].name + sku,
                            numberOfProducts, 
                            numberOfOrders, 
                            total:total.toFixed(2),
                            averagePrice,
                            isMarginCalculationActivated
                          })
                        }
                      }
                      
                    }
                  }
                }
              })
            }
            return table
          }
          return table
        }
        else {
          if(timeFrame === "thisYear" || timeFrame === "lastYear") {
            year = timeFrame === "lastYear" ? year - 1 : year
            salespersons.forEach(salesperson => {
              table.push({...salesperson, total:this.salespersonsBase[salesperson.id][year]["year"][metric].toFixed(2)})
            })
            return table
          }
          else if(timeFrame === "thisWeek" || timeFrame === "lastWeek") {
            week = this.getWeek(new Date())
            week = timeFrame === "lastWeek" ? week - 1 : week
            if(week < 1){
              year = year - 1
              week = 52
            }
            salespersons.forEach(salesperson => {
              table.push({...salesperson, total:this.salespersonsBase[salesperson.id][year]["weeks"][week][metric].toFixed(2)})
            })
            return table
          }
          else if(timeFrame === "thisMonth" || timeFrame === "lastMonth") {
            month = new Date().getMonth()+1
            month = timeFrame === "lastMonth" ? month - 1 : month
            if(month < 1){
              year = year - 1
              month = 12
            }
            salespersons.forEach(salesperson => {
              table.push({...salesperson, total:this.salespersonsBase[salesperson.id][year]["months"][month][metric].toFixed(2)})
            })
            return table
          }
        }
      },
      getChartData(filter,metric,timeSplit,year,splitSalespersons){
        if(this.salespersonsBase[filter] === undefined) return
        var salespersons = []
        if(metric === 'agreedVisits') { 
          
          Object.keys(this.staff).forEach(id =>{
            if(this.staff[id].weekReportingRequired) salespersons.push({id,firstName:this.staff[id].firstName})
          })
        }
        else salespersons = this.getSalespersons()
        if(timeSplit === "months"){
          
          // SALESPERSON SPLIT
          if (splitSalespersons){
            var figuresBySalesperson = {}
            salespersons.forEach(salesperson => { 
              figuresBySalesperson[salesperson.id] = []
              if(metric === 'warehouseProductSales'){
                this.months.forEach(month => {
                  var share = 0
                  if(this.salespersonsBase[salesperson.id][year]["months"][month]['sales'] !== 0){
                    share = this.salespersonsBase[salesperson.id][year]["months"][month]['warehouseProductSales']/this.salespersonsBase[salesperson.id][year]["months"][month]['sales']
                    share = share * 100
                    share = share.toFixed(2)
                  }
                  figuresBySalesperson[salesperson.id].push(share)
                })
              }
              else{
                this.months.forEach(month => {
                  if(!this.salespersonsBase[salesperson.id][year]) console.log(this.salespersonsBase[salesperson.id],year)
                  figuresBySalesperson[salesperson.id].push(this.salespersonsBase[salesperson.id][year]["months"][month][metric])
                })
              }  
            })
            var data = []
            for (const key in figuresBySalesperson){
              data.push({
                name: this.staff[key].firstName,
                data:figuresBySalesperson[key]
              })
            }
          }
          // TOTAL
          else {
            var figures = []
            var goalFigures = []
            
            this.months.forEach(month => {
              if(metric === 'warehouseProductSales'){
                var share = 0
                if(this.salespersonsBase[filter][year]["months"][month]['sales'] !== 0){
                  share = this.salespersonsBase[filter][year]["months"][month]['warehouseProductSales']/this.salespersonsBase[filter][year]["months"][month]['sales']
                  share = share * 100
                  share = share.toFixed(2)
                }
                figures.push(share)
              }
              else {
                if(metric === 'agreedVisits') { 
                  //console.log(filter,metric,timeSplit,year,splitSalespersons)
                  //console.log(this.salespersonsBase[filter][year]["months"][month][metric])
                }
                figures.push(this.salespersonsBase[filter][year]["months"][month][metric])
              }
              if(year !== 2019){
                if(metric === "sales") goalFigures.push(this.salespersonsBase[filter][year]["months"][month]["salesGoals"])
                if(metric === "marginRate") goalFigures.push(this.salespersonsBase[filter][year]["months"][month]["marginRateGoals"])
                if(metric === "margins") goalFigures.push(this.salespersonsBase[filter][year]["months"][month]["marginGoals"])
              }
            })
            var data = [
              {
                name: "Toteutuma",
                data:figures
              }
            ]
            if(year !== 2019){
              if(metric === "sales" || metric === "marginRate" || (metric === "margins" && year > 2023) ) {
                if(filter === 'GTNKFjWUHNhcAJVbORirRPNvCnv1' && this.user.uid ==='GTNKFjWUHNhcAJVbORirRPNvCnv1'){} // Atelta pois tavoitteet
                else {
                  data.push( data.push({name:"Tavoite", data:goalFigures}))
                }
              }
            }
          }
        }
        else if (timeSplit === "weeks"){
          if (splitSalespersons){
            var figuresBySalesperson = {}
            salespersons.forEach(salesperson => { 
              figuresBySalesperson[salesperson.id] = []
              this.weeks.forEach(week => {
                figuresBySalesperson[salesperson.id].push(this.salespersonsBase[salesperson.id][year]["weeks"][week][metric])
              })  
            })
            var data = []
            for (const key in figuresBySalesperson){
              data.push({
                name: this.staff[key].firstName,
                data:figuresBySalesperson[key]
              })
            }
          }
          else {
            var figures = []
            this.weeks.forEach(week => {
              figures.push(this.salespersonsBase[filter][year]["weeks"][week][metric])
            })
            var data = [
              {
                name: "Toteutuma",
                data:figures
              }
            ]
          }
        }
        /* if(metric === 'agreedVisits') {
          console.log(filter,metric,timeSplit,year,splitSalespersons)
          console.log(data)
        } */
        return data
      },
      generateCompetitionActualData(){
        var competitionsBase = this.competitionsBase
        var competitions = this.getCompetitions
        var orderedProducts = this.orderedProducts
        var orders = this.orders
        Object.keys(this.orderedProducts).forEach(function(key, index) {
          var op = orderedProducts[key]
          if(orders[op.orderId] === undefined) {return}
          var salespersonId = orders[op.orderId].salesperson
          
          competitions.forEach(c => {
            var startDate = new Date(c.startDate)
            var startDateOneYearBefore = new Date(new Date(c.startDate).setFullYear(new Date(c.startDate).getFullYear() - 1))
            //console.log({startDate,startDateOneYearBefore})
            var endDate = new Date(c.endDate)
            var endDateOneYearBefore = new Date(new Date(c.endDate).setFullYear(new Date(c.endDate).getFullYear() - 1))
            //console.log({endDate,endDateOneYearBefore})
            var opCreatedDate = new Date(op.created_at.seconds * 1000)
            //console.log({startDate,endDate,opCreatedDate})
            // PREVIOUS YEAR
            if(startDateOneYearBefore < opCreatedDate && endDateOneYearBefore > opCreatedDate){
              
              var continuee = false
              if(c.products.length === 0) continuee = true
              else if(c.products.length > 0 && c.products.includes(op.productVariationId)) continuee = true
              if(!continuee) return
              
              if(c.metric === 'sales') {
                var total = 0
                if(op.orderStatus !== 'cancelled'){
                  total += op.unitPrice && op.quantity ? op.unitPrice * op.quantity : 0
                  total += op.unitPrintPrice && op.printQuantity ? op.unitPrintPrice * op.printQuantity : 0
                  total += op.pricePerPositioning && op.numberOfPositionings ? op.pricePerPositioning * op.numberOfPositionings : 0
                  total = Math.round(Number(total))
                }
                if(competitionsBase[c.id] && competitionsBase[c.id][salespersonId]){
                  competitionsBase[c.id][salespersonId].previousYearResult += total
                }
                competitionsBase[c.id]['all'].previousYearResult += total
              }
            }
            // THIS YEAR
            if(startDate < opCreatedDate && endDate > opCreatedDate){
              var continuee = false
              if(c.products.length === 0) continuee = true
              else if(c.products.length > 0 && c.products.includes(op.productVariationId)) continuee = true
              if(!continuee) return
              
              if(c.metric === 'sales') {
                var total = 0
                if(op.orderStatus !== 'cancelled'){
                  total = op.unitPrice && op.quantity ? op.unitPrice * op.quantity : 0
                  total += op.unitPrintPrice && op.printQuantity ? op.unitPrintPrice * op.printQuantity : 0
                  total += op.pricePerPositioning && op.numberOfPositionings ? op.pricePerPositioning * op.numberOfPositionings : 0
                  total = Math.round(Number(total))
                }
                if(competitionsBase[c.id] && competitionsBase[c.id][salespersonId]){
                  competitionsBase[c.id][salespersonId].result += total
                }
                competitionsBase[c.id]['all'].result += total
              }
            }
          })
        })
        Object.keys(this.orders).forEach(function(key, index) {
          var o = orders[key]
          var salespersonId = o.salesperson
          competitions.forEach(c => {
            var startDate = new Date(c.startDate)
            var startDateOneYearBefore = new Date(new Date(c.startDate).setFullYear(new Date(c.startDate).getFullYear() - 1))
            var endDate = new Date(c.endDate)
            var endDateOneYearBefore = new Date(new Date(c.endDate).setFullYear(new Date(c.endDate).getFullYear() - 1))
            var oCreatedDate = new Date(o.created_at.seconds * 1000)
            //console.log({startDate,endDate,opCreatedDate})
            if(startDateOneYearBefore < oCreatedDate && endDateOneYearBefore > oCreatedDate){
              if(c.metric === 'margins'){
                if(competitionsBase[c.id][salespersonId]){
                  competitionsBase[c.id][salespersonId].previousYearResult += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
                }
                competitionsBase[c.id]['all'].previousYearResult += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
              }
              if(c.metric === 'orders'){
                if(competitionsBase[c.id][salespersonId]){
                  competitionsBase[c.id][salespersonId].previousYearResult += 1
                }
                competitionsBase[c.id]['all'].previousYearResult += 1
              }
            
            
            }
            if(startDate < oCreatedDate && endDate > oCreatedDate){
              if(c.metric === 'margins'){
                if(competitionsBase[c.id][salespersonId]){
                  competitionsBase[c.id][salespersonId].result += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
                }
                competitionsBase[c.id]['all'].result += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
              }
              if(c.metric === 'orders'){
                if(competitionsBase[c.id][salespersonId]){
                  competitionsBase[c.id][salespersonId].result += 1
                }
                competitionsBase[c.id]['all'].result += 1
              }
            }
          })

        })
      },
      generateActualData(){
        var orderedProducts = this.orderedProducts
        var products = this.products
        var productVariations = this.productVariations
        var orders = this.orders
        var staff = this.staff
        var companies = this.companies
        var getWeek = this.getWeek
        var salespersonsBase = this.salespersonsBase
        var companiesBase = this.companiesBase
        var productVariationsBase = this.productVariationsBase
        var t = this
        var minYear = 2022
        Object.keys(this.orderedProducts).forEach(function(key, index) {
          var op = orderedProducts[key]
          if(orders[op.orderId] === undefined) {
            //console.log("ORDER ID UNDEFINED: "+ op.orderId + " VIA OP ID: "+ op.id)
            return
          }
          if(orders[op.orderId].sample !== undefined && orders[op.orderId].sample) return
          var salesperson = orders[op.orderId].salesperson
          if (salespersonsBase[salesperson] === undefined) return
          var total = 0
          var created_at = null
          if(orders[op.orderId].created_at.seconds){
            created_at = orders[op.orderId].created_at.toDate()
          }
          else {
            console.log(orders[op.orderId].created_at)
            created_at = new Date(orders[op.orderId].created_at)
          }
          var month = created_at.getMonth()+1
          var week = getWeek(created_at)
          if(week == 0){
            console.log(created_at)
            console.log(orders[op.orderId])
          }
          //metric === "sales" ? console.log(month) : ""
          var year = created_at.getFullYear()
          if(year < minYear) return
          var salesperson = orders[op.orderId].salesperson
         if(op.orderStatus !== 'cancelled'){
          total = op.unitPrice && op.quantity ? op.unitPrice * op.quantity : 0
          total += op.unitPrintPrice && op.printQuantity ? op.unitPrintPrice * op.printQuantity : 0
          total += op.pricePerPositioning && op.numberOfPositionings ? op.pricePerPositioning * op.numberOfPositionings : 0
          if(isNaN(total)) {
            console.log("******* INCORRECTLY INSERTED PRICE/QUANTITY DATA RESULTING IN NAN ******")
            console.log(op)
            console.log("************************************************************************")
            return
          }
         }

          // 32
          //console.log(this.salespersonsBase[salesperson.id][year]["weeks"][week][metric])

          total = Math.round(Number(total))
          var pvId = op.productVariationId
          var comId = orders[op.orderId].companyId
          // PRODUCT VARIATIONS
          if(productVariations[pvId] && products[productVariations[pvId].productId]){
            var variationName = ''
            if(t.createVariationName) variationName = t.createVariationName(productVariations[pvId])
            productVariationsBase ? '' : productVariationsBase = {}
            if(salesperson){
              productVariationsBase[salesperson] ? '' : productVariationsBase[salesperson] = {}
              productVariationsBase[salesperson][pvId] ? '' : productVariationsBase[salesperson][pvId] = {}
              productVariationsBase[salesperson][pvId].name ? '' : productVariationsBase[salesperson][pvId].name = products[productVariations[pvId].productId].name.fi + ' - ' + variationName
              productVariationsBase[salesperson][pvId][year] ? '' : productVariationsBase[salesperson][pvId][year] = {}
              productVariationsBase[salesperson][pvId][year]["year"] ? '' : productVariationsBase[salesperson][pvId][year]["year"] = {}
              productVariationsBase[salesperson][pvId][year]["year"]['sales'] ? productVariationsBase[salesperson][pvId][year]["year"]['sales'] += total  : productVariationsBase[salesperson][pvId][year]["year"]['sales'] = total 
              productVariationsBase[salesperson][pvId][year]["year"]['numberOfProducts'] ? productVariationsBase[salesperson][pvId][year]["year"]['numberOfProducts'] += Number(op.quantity)  :  productVariationsBase[salesperson][pvId][year]["year"]['numberOfProducts'] = Number(op.quantity)
            } 
            
            productVariationsBase['all'] ? '' : productVariationsBase['all'] = {}
            productVariationsBase['all'][pvId] ? '' : productVariationsBase['all'][pvId] = {}
            productVariationsBase['all'][pvId].name ? '' : productVariationsBase['all'][pvId].name = products[productVariations[pvId].productId].name.fi + ' - ' + variationName + ' (' + products[productVariations[pvId].productId].avecorSku + ')'
            productVariationsBase['all'][pvId][year] ? '' : productVariationsBase['all'][pvId][year] = {}
            productVariationsBase['all'][pvId][year]["year"] ? '' : productVariationsBase['all'][pvId][year]["year"] = {}
            productVariationsBase['all'][pvId][year]["year"]['sales'] ? productVariationsBase['all'][pvId][year]["year"]['sales'] += total  : productVariationsBase['all'][pvId][year]["year"]['sales'] = total 
            productVariationsBase['all'][pvId][year]["year"]['numberOfProducts'] ? productVariationsBase['all'][pvId][year]["year"]['numberOfProducts'] += Number(op.quantity)  :  productVariationsBase['all'][pvId][year]["year"]['numberOfProducts'] = Number(op.quantity)
          }
          
          // COMPANIES
          if(orders[op.orderId] && comId){
            companiesBase ? '' : companiesBase = {}
            if(salesperson){
              companiesBase[salesperson] ? '' : companiesBase[salesperson] = {}
              companiesBase[salesperson][comId] ? '' : companiesBase[salesperson][comId] = {}
              companiesBase[salesperson][comId].name ? '' : companiesBase[salesperson][comId].name = companies[comId].companyName
              companiesBase[salesperson][comId].salespersonId ? '' : companiesBase[salesperson][comId].salespersonId = orders[op.orderId].salesperson
              companiesBase[salesperson][comId].salespersonName ? '' : companiesBase[salesperson][comId].salespersonName = staff[orders[op.orderId].salesperson].firstName
              companiesBase[salesperson][comId][year] ? '' : companiesBase[salesperson][comId][year] = {}
              companiesBase[salesperson][comId][year]["year"] ? '' : companiesBase[salesperson][comId][year]['year'] = {}
              companiesBase[salesperson][comId][year]["year"]['sales'] ? companiesBase[salesperson][comId][year]['year']['sales'] += total :  companiesBase[salesperson][comId][year]['year']['sales'] = total
            }

            companiesBase ? '' : companiesBase = {}
            companiesBase['all'] ? '' : companiesBase['all'] = {}
            companiesBase['all'][comId] ? '' : companiesBase['all'][comId] = {}
            companiesBase['all'][comId].name ? '' : companiesBase['all'][comId].name = companies[comId].companyName
            companiesBase['all'][comId].salespersonId ? '' : companiesBase['all'][comId].salespersonId = orders[op.orderId].salesperson
            companiesBase['all'][comId].salespersonName ? '' : companiesBase['all'][comId].salespersonName = staff[orders[op.orderId].salesperson].firstName
            companiesBase['all'][comId][year] ? '' : companiesBase['all'][comId][year] = {}
            companiesBase['all'][comId][year]["year"] ? '' : companiesBase['all'][comId][year]['year'] = {}
            companiesBase['all'][comId][year]["year"]['sales'] ? companiesBase['all'][comId][year]['year']['sales'] += total :  companiesBase['all'][comId][year]['year']['sales'] = total
          }
          
          // SALES
          if(!salespersonsBase["all"][year])console.log(year)
          salespersonsBase["all"][year]["year"]["sales"] += total
          salespersonsBase["all"][year]["months"][month]["sales"] += total
          if(salespersonsBase["all"][year]["weeks"][week] === undefined) console.log(week)
          salespersonsBase["all"][year]["weeks"][week]["sales"] += total
          salespersonsBase[salesperson][year]["year"]["sales"] += total
          salespersonsBase[salesperson][year]["months"][month]["sales"] += total
          salespersonsBase[salesperson][year]["weeks"][week]["sales"] += total

          // WAREHOUSE SALES
          if(productVariations[pvId] && productVariations[pvId].warehoused){
            salespersonsBase["all"][year]["year"]["warehouseProductSales"] += total
            salespersonsBase["all"][year]["months"][month]["warehouseProductSales"] += total
            salespersonsBase["all"][year]["weeks"][week]["warehouseProductSales"] += total
            salespersonsBase[salesperson][year]["year"]["warehouseProductSales"] += total
            salespersonsBase[salesperson][year]["months"][month]["warehouseProductSales"] += total
            salespersonsBase[salesperson][year]["weeks"][week]["warehouseProductSales"] += total
          }
          
        })
        Object.keys(this.orders).forEach(function(key, index) {
          var o = orders[key]
          if(o.sample !== undefined && o.sample) return
          if(typeof companies[o.companyId] === "undefined") return {...o}
          var total = 0
          var salesperson = o.salesperson
          if (salespersonsBase[salesperson] === undefined) return
          
          var created_at = null
          if(companies[o.companyId].created_at.seconds){created_at = companies[o.companyId].created_at.toDate()}
          else {created_at = new Date(companies[o.companyId].created_at)}

          var companyMonth = created_at.getMonth() + 1
          var companyYear = created_at.getFullYear()
          var companyWeek = getWeek(created_at)
          
          if(companyYear >= minYear){
            salespersonsBase["all"][companyYear]["year"]["newCustomers"] += 1
            salespersonsBase["all"][companyYear]["months"][companyMonth]["newCustomers"] += 1
            salespersonsBase["all"][companyYear]["weeks"][companyWeek]["newCustomers"] += 1
            salespersonsBase[salesperson][companyYear]["year"]["newCustomers"] += 1
            salespersonsBase[salesperson][companyYear]["months"][companyMonth]["newCustomers"] += 1
            salespersonsBase[salesperson][companyYear]["weeks"][companyWeek]["newCustomers"] += 1
          }
          

          if(o.created_at.seconds){created_at = o.created_at.toDate()}
          else {created_at = new Date(o.created_at)}


          var orderMonth = created_at.getMonth() +1
          var orderYear = created_at.getFullYear()
          var orderWeek = getWeek(created_at)
          if(orderYear >= minYear){
            salespersonsBase["all"][orderYear]["year"]["orders"] += 1
            salespersonsBase["all"][orderYear]["months"][orderMonth]["orders"] += 1
            salespersonsBase["all"][orderYear]["weeks"][orderWeek]["orders"] += 1
            salespersonsBase[salesperson][orderYear]["year"]["orders"] += 1
            salespersonsBase[salesperson][orderYear]["months"][orderMonth]["orders"] += 1
            salespersonsBase[salesperson][orderYear]["weeks"][orderWeek]["orders"] += 1

            salespersonsBase["all"][orderYear]["year"]["margins"] += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
            salespersonsBase["all"][orderYear]["months"][orderMonth]["margins"] += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
            salespersonsBase["all"][orderYear]["weeks"][orderWeek]["margins"] += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
            salespersonsBase[salesperson][orderYear]["year"]["margins"] += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
            salespersonsBase[salesperson][orderYear]["months"][orderMonth]["margins"] += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
            salespersonsBase[salesperson][orderYear]["weeks"][orderWeek]["margins"] += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
          }
        })
        
        // MARGIN RATES
        this.getAllSalespersons().forEach(salesperson => {
          this.years.forEach(year => {
            if(year < minYear) return
            var divider = salespersonsBase[salesperson.id][year]["year"]["sales"]-salespersonsBase[salesperson.id][year]["year"]["margins"]
            salespersonsBase[salesperson.id][year]["year"]["marginRate"] += divider != 0 ? parseFloat((salespersonsBase[salesperson.id][year]["year"]["sales"]/divider).toFixed(2)) : 0
            this.months.forEach(month => {
              divider = salespersonsBase[salesperson.id][year]["months"][month]["sales"]-salespersonsBase[salesperson.id][year]["months"][month]["margins"]
              salespersonsBase[salesperson.id][year]["months"][month]["marginRate"] = divider != 0 ? parseFloat((salespersonsBase[salesperson.id][year]["months"][month]["sales"]/divider).toFixed(2)) : 0
            })
            this.weeks.forEach(week => {
              divider = salespersonsBase[salesperson.id][year]["weeks"][week]["sales"]-salespersonsBase[salesperson.id][year]["weeks"][week]["margins"]
              salespersonsBase[salesperson.id][year]["weeks"][week]["marginRate"] = divider != 0 ? parseFloat((salespersonsBase[salesperson.id][year]["weeks"][week]["sales"]/divider).toFixed(2)) : 0
            })
          })
        })
        this.years.forEach(year => {
          if(year < minYear) return
          var divider = salespersonsBase["all"][year]["year"]["sales"] - salespersonsBase["all"][year]["year"]["margins"]
          salespersonsBase["all"][year]["year"]["marginRate"] = divider != 0 ? parseFloat((salespersonsBase["all"][year]["year"]["sales"]/divider).toFixed(2)) : 0
          this.months.forEach(month => {
            divider = salespersonsBase["all"][year]["months"][month]["sales"] - salespersonsBase["all"][year]["months"][month]["margins"]
            salespersonsBase["all"][year]["months"][month]["marginRate"] = divider != 0 ? parseFloat((salespersonsBase["all"][year]["months"][month]["sales"]/divider).toFixed(2)) : 0
          })
          this.weeks.forEach(week => {
            divider = salespersonsBase["all"][year]["weeks"][week]["sales"] - salespersonsBase["all"][year]["weeks"][week]["margins"]
            salespersonsBase["all"][year]["weeks"][week]["marginRate"] = divider != 0 ? parseFloat((salespersonsBase["all"][year]["weeks"][week]["sales"]/divider).toFixed(2)) : 0
          })
        })

        // GOALS
        this.getAllSalespersons().forEach(salesperson => {
          this.years.forEach(year => {
            if(year < minYear) return
            if (year == 2019) return
            this.months.forEach(month => {
              if(this.staff[salesperson.id].goals === undefined) return
              salespersonsBase[salesperson.id][year]["year"]["salesGoals"] += parseInt(this.staff[salesperson.id].goals[year][month])
              salespersonsBase[salesperson.id][year]["year"]["marginRateGoals"] += parseFloat(this.staff[salesperson.id].marginRateGoals[year][month])
              if(this.staff[salesperson.id].marginGoals[year]) {
                salespersonsBase[salesperson.id][year]["year"]["marginGoals"] += parseFloat(this.staff[salesperson.id].marginGoals[year][month])
              }
              salespersonsBase[salesperson.id][year]["months"][month]["salesGoals"] = parseInt(this.staff[salesperson.id].goals[year][month])
              salespersonsBase[salesperson.id][year]["months"][month]["marginRateGoals"] += parseFloat(this.staff[salesperson.id].marginRateGoals[year][month])
              if(this.staff[salesperson.id].marginGoals[year]) {
                salespersonsBase[salesperson.id][year]["months"][month]["marginGoals"] += parseFloat(this.staff[salesperson.id].marginGoals[year][month])
              }

              salespersonsBase["all"][year]["year"]["salesGoals"] += parseInt(this.staff[salesperson.id].goals[year][month])
              salespersonsBase["all"][year]["year"]["marginRateGoals"] += parseFloat(this.staff[salesperson.id].marginRateGoals[year][month])
              if(this.staff[salesperson.id].marginGoals[year]) {
                salespersonsBase["all"][year]["year"]["marginGoals"] += parseFloat(this.staff[salesperson.id].marginGoals[year][month])
              }
              salespersonsBase["all"][year]["months"][month]["salesGoals"] += parseInt(this.staff[salesperson.id].goals[year][month])
              salespersonsBase["all"][year]["months"][month]["marginRateGoals"] += parseFloat(this.staff[salesperson.id].marginRateGoals[year][month])
              if(this.staff[salesperson.id].marginGoals[year]) {
                salespersonsBase["all"][year]["months"][month]["marginGoals"] += parseFloat(this.staff[salesperson.id].marginGoals[year][month])
              }
            })
          })
        })
        this.years.forEach(year => {
          if(year < minYear) return
          if (year == 2019) return
          this.months.forEach(month => {
            salespersonsBase["all"][year]["months"][month]["marginRateGoals"] = parseFloat((salespersonsBase["all"][year]["months"][month]["marginRateGoals"]/12).toFixed(2))
          })
        })
        var numberOfSalesPersons = 0
        this.getAllSalespersons().forEach(salesperson => {
          if(this.staff[salesperson.id].goals === undefined) return
          this.years.forEach(year => {
            if(year < minYear) return
            if (year == 2019) return
            salespersonsBase[salesperson.id][year]["year"]["marginRateGoals"] = parseFloat((salespersonsBase[salesperson.id][year]["year"]["marginRateGoals"]/12).toFixed(2))
          })
          numberOfSalesPersons += 1
        })
        this.years.forEach(year => {
          if (year == 2019) return
          if(year < minYear) return
          this.months.forEach(month => {
            salespersonsBase["all"][year]["year"]["marginRateGoals"] = parseFloat((salespersonsBase["all"][year]["year"]["marginRateGoals"]/(12*numberOfSalesPersons)).toFixed(2))
          })
        })
        //console.log(salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"])
      },
      getWeek(date) {
        var dowOffset = 1
        var newYear = new Date(date.getFullYear(),0,1);
        var day = newYear.getDay() - dowOffset; //the day of week the year begins on
        day = (day >= 0 ? day : day + 7);
        var daynum = Math.floor((date.getTime() - newYear.getTime() - 
        (date.getTimezoneOffset()-newYear.getTimezoneOffset())*60000)/86400000) + 1;
        var weeknum;
        //if the year starts before the middle of a week
        if(day < 4) {
            weeknum = Math.floor((daynum+day-1)/7) + 1;
            if(weeknum > 52) {
                nYear = new Date(date.getFullYear() + 1,0,1);
                nday = nYear.getDay() - dowOffset;
                nday = nday >= 0 ? nday : nday + 7;
                /*if the next year starts before the middle of
                  the week, it is week #1 of that year*/
                weeknum = nday < 4 ? 1 : 53;
            }
        }
        else {
            weeknum = Math.floor((daynum+day-1)/7);
        }
        if(weeknum == 0) weeknum = 1
        return weeknum;
      },
      generateActualDataForAgreedVisits(){
        Object.keys(this.staff).forEach(id =>{
          if(this.staff[id].weekReports !== undefined && this.staff[id].weekReportingRequired) {
            this.years.forEach(year => {
              if(this.staff[id].weekReports[year] !== undefined){
                var y = this.staff[id].weekReports[year]
                Object.keys(y).forEach(monthNo => {
                  var m = y[monthNo]
                  Object.keys(m).forEach(weekNo => {
                    var w = m[weekNo]
                    if(!this.salespersonsBase[id][year]) this.salespersonsBase[id][year] = {}
                    if(!this.salespersonsBase[id][year]["year"]) this.salespersonsBase[id][year]["year"] = {}
                    if(!this.salespersonsBase[id][year]["weeks"]) this.salespersonsBase[id][year]["weeks"] = {}
                    if(!this.salespersonsBase[id][year]["weeks"][weekNo]) this.salespersonsBase[id][year]["weeks"][weekNo] = {}
                    if(!this.salespersonsBase[id][year]["months"]) this.salespersonsBase[id][year]["months"] = {}
                    if(!this.salespersonsBase[id][year]["months"][monthNo]) this.salespersonsBase[id][year]["months"][monthNo] = {}
                    
                    this.salespersonsBase[id][year]["year"]['agreedVisits'] += isNaN(Number(w.agreedVisits)) ? 0 : Number(w.agreedVisits)
                    this.salespersonsBase[id][year]["weeks"][weekNo]['agreedVisits'] += isNaN(Number(w.agreedVisits)) ? 0 : Number(w.agreedVisits)
                    this.salespersonsBase[id][year]["months"][monthNo]['agreedVisits'] += isNaN(Number(w.agreedVisits)) ? 0 : Number(w.agreedVisits)
                  })
                })
              }
            })
          } 
        })
      },
      getLastSunday(){
        var d = new Date();
        d.setHours(0,0,0,0);
        switch (d.getDay())
          {
          case 0: d.setDate(d.getDate() -7);
          break;
          case 1: d.setDate(d.getDate() -1);
          break;
          case 2: d.setDate(d.getDate() -2);
          break;
          case 3: d.setDate(d.getDate() -3);
          break;
          case 4: d.setDate(d.getDate() -4);
          break;
          case 5: d.setDate(d.getDate() -5);
          break;
          case 6: d.setDate(d.getDate() -6);
          break;
        }
        return d;
      },
      getLastLastSunday(){
        var d = new Date();
        d.setHours(0,0,0,0);
        switch (d.getDay())
        {
          case 0: d.setDate(d.getDate() -14);
          break;
          case 1: d.setDate(d.getDate() -8);
          break;
          case 2: d.setDate(d.getDate() -9);
          break;
          case 3: d.setDate(d.getDate() -10);
          break;
          case 4: d.setDate(d.getDate() -11);
          break;
          case 5: d.setDate(d.getDate() -12);
          break;
          case 6: d.setDate(d.getDate() -13);
          break;
        }
        return d;
      },
      getThisMonthStart(){
        var d = new Date();
        var dd = new Date(d.getFullYear(),d.getMonth(),1)
        return dd;
      },
      getPreviousMonthStart(){
        var d = new Date();
        var dd = new Date(d.getFullYear(),d.getMonth()-1,1)
        return dd;
      },
      getThisYearStart(){
        var d = new Date();
        var dd = new Date(d.getFullYear(),0,1)
        return dd;
      },
      getLastYearStart(){
        var d = new Date();
        var dd = new Date(d.getFullYear()-1,0,1)
        return dd;
      },    

      set2019Numbers(){
        this.salespersonsBase["all"][2019]["months"][1]["margins"] = 46851.15
        this.salespersonsBase["all"][2019]["months"][1]["sales"] = 76898.81
        this.salespersonsBase["all"][2019]["months"][1]["orders"] = 89
        this.salespersonsBase["all"][2019]["months"][1]["newCustomers"] = 42
        this.salespersonsBase["all"][2019]["months"][2]["margins"] = 47245.17
        this.salespersonsBase["all"][2019]["months"][2]["sales"] = 83150.15
        this.salespersonsBase["all"][2019]["months"][2]["orders"] = 106
        this.salespersonsBase["all"][2019]["months"][2]["newCustomers"] = 59
        this.salespersonsBase["all"][2019]["months"][3]["margins"] = 58525.7
        this.salespersonsBase["all"][2019]["months"][3]["sales"] = 135356.04
        this.salespersonsBase["all"][2019]["months"][3]["orders"] = 159
        this.salespersonsBase["all"][2019]["months"][3]["newCustomers"] = 110
        this.salespersonsBase["all"][2019]["months"][4]["margins"] = 62342.86
        this.salespersonsBase["all"][2019]["months"][4]["sales"] = 102185.87
        this.salespersonsBase["all"][2019]["months"][4]["orders"] = 136
        this.salespersonsBase["all"][2019]["months"][4]["newCustomers"] = 79
        this.salespersonsBase["all"][2019]["months"][5]["margins"] = 1272.28
        this.salespersonsBase["all"][2019]["months"][5]["sales"] = 2044.82
        this.salespersonsBase["all"][2019]["months"][5]["orders"] = 4
        this.salespersonsBase["all"][2019]["months"][5]["newCustomers"] = 2

        this.salespersonsBase["all"][2019]["year"]["margins"] = this.salespersonsBase["all"][2019]["months"][1]["margins"] + this.salespersonsBase["all"][2019]["months"][2]["margins"] +this.salespersonsBase["all"][2019]["months"][3]["margins"]+ this.salespersonsBase["all"][2019]["months"][4]["margins"]+this.salespersonsBase["all"][2019]["months"][5]["margins"]
        this.salespersonsBase["all"][2019]["year"]["sales"] = this.salespersonsBase["all"][2019]["months"][1]["sales"] + this.salespersonsBase["all"][2019]["months"][2]["sales"] +this.salespersonsBase["all"][2019]["months"][3]["sales"]+ this.salespersonsBase["all"][2019]["months"][4]["sales"]+this.salespersonsBase["all"][2019]["months"][5]["sales"]
        this.salespersonsBase["all"][2019]["year"]["orders"] = this.salespersonsBase["all"][2019]["months"][1]["orders"] + this.salespersonsBase["all"][2019]["months"][2]["orders"] +this.salespersonsBase["all"][2019]["months"][3]["orders"]+ this.salespersonsBase["all"][2019]["months"][4]["orders"]+this.salespersonsBase["all"][2019]["months"][5]["orders"]
        this.salespersonsBase["all"][2019]["year"]["newCustomers"] = this.salespersonsBase["all"][2019]["months"][1]["newCustomers"] + this.salespersonsBase["all"][2019]["months"][2]["newCustomers"] +this.salespersonsBase["all"][2019]["months"][3]["newCustomers"]+ this.salespersonsBase["all"][2019]["months"][4]["newCustomers"]+this.salespersonsBase["all"][2019]["months"][5]["newCustomers"]
        //ATTE
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][1]["margins"] = 7766.95
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][1]["sales"] = 12670.55
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][1]["orders"] = 14
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][1]["newCustomers"] = 6
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][2]["margins"] = 7252.09
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][2]["sales"] = 13184.35
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][2]["orders"] = 18
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][2]["newCustomers"] = 9
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][3]["margins"] = 8405.74
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][3]["sales"] = 15544
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][3]["orders"] = 22
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][3]["newCustomers"] = 8
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][4]["margins"] = 8376 //8376.36
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][4]["sales"] = 13597 //13597.31
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][4]["orders"] = 24
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][4]["newCustomers"] = 4
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][5]["margins"] = 566.57
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][5]["sales"] = 1016.57
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][5]["orders"] = 1
        this.salespersonsBase["GTNKFjWUHNhcAJVbORirRPNvCnv1"][2019]["months"][5]["newCustomers"] = 0
        //HANNA
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][1]["margins"] = 11070.99
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][1]["sales"] = 17147.10
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][1]["orders"] = 20
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][1]["newCustomers"] = 5
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][2]["margins"] = 13164.39
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][2]["sales"] = 20945.7
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][2]["orders"] = 20
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][2]["newCustomers"] = 1
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][3]["margins"] = 6648.42
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][3]["sales"] = 13258.52
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][3]["orders"] = 15
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][3]["newCustomers"] = 9
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][4]["margins"] = 5413.02
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][4]["sales"] = 10185.05
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][4]["orders"] = 17
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][4]["newCustomers"] = 2
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][5]["margins"] = 436.02
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][5]["sales"] = 588.2
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][5]["orders"] = 1
        this.salespersonsBase["2hq19s6eQHSrEhwXiAeDGxo0Q5e2"][2019]["months"][5]["newCustomers"] = 1
        //MARKKU
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][1]["margins"] = 2492.36
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][1]["sales"] = 4022.6
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][1]["orders"] = 21
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][1]["newCustomers"] = 4
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][2]["margins"] = 5550.93
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][2]["sales"] = 8345.3
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][2]["orders"] = 19
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][2]["newCustomers"] = 8
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][3]["margins"] = 3349.55
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][3]["sales"] = 5926.6
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][3]["orders"] = 27
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][3]["newCustomers"] = 6
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][4]["margins"] = 4006.59
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][4]["sales"] = 6001.9
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][4]["orders"] = 19
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][4]["newCustomers"] = 4
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][5]["margins"] = 70.20
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][5]["sales"] = 124.8
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][5]["orders"] = 1
        this.salespersonsBase["eZ4PiIehfVg7xo0J2tZV8tYtLZ23"][2019]["months"][5]["newCustomers"] = 0
        //TIMO
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][1]["margins"] = 5389.62,
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][1]["sales"] = 9799
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][1]["orders"] = 5
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][1]["newCustomers"] = 0
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][2]["margins"] = 870
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][2]["sales"] = 2545
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][2]["orders"] = 3
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][2]["newCustomers"] = 8
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][3]["margins"] = 322.2
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][3]["sales"] = 768.7
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][3]["orders"] = 2
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][3]["newCustomers"] = 2
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][4]["margins"] = 6701.4
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][4]["sales"] = 10777.8
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][4]["orders"] = 4
        this.salespersonsBase["RqjgIwdXWzXqCR2MOVr1etp2iY22"][2019]["months"][4]["newCustomers"] = 2
        //HENRI
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][1]["margins"] = 20131.23,
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][1]["sales"] = 33259.56
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][1]["orders"] = 29
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][1]["newCustomers"] = 27
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][2]["margins"] = 14195.69
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][2]["sales"] = 27051
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][2]["orders"] = 26
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][2]["newCustomers"] = 21
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][3]["margins"] = 11620.02
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][3]["sales"] = 44090.1
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][3]["orders"] = 21
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][3]["newCustomers"] = 17
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][4]["margins"] = 16800 //16800.19
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][4]["sales"] = 28456 //28456.12
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][4]["orders"] = 22
        this.salespersonsBase["zNBbbWRgacVUU3TU06kTSLesn872"][2019]["months"][4]["newCustomers"] = 18
        //SAMI
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][2]["margins"] = 6212.07
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][2]["sales"] = 11078.8
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][2]["orders"] = 20
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][2]["newCustomers"] = 20
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][3]["margins"] = 15420.06
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][3]["sales"] = 31177.12
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][3]["orders"] = 47
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][3]["newCustomers"] = 43
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][4]["margins"] = 9870 //9870.85
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][4]["sales"] = 18547.24
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][4]["orders"] = 35
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][4]["newCustomers"] = 34
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][5]["margins"] = 199 //199.49
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][5]["sales"] = 315.25
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][5]["orders"] = 1
        this.salespersonsBase["CfssvG9CYWWCoLSkeoR6FVXy6K72"][2019]["months"][5]["newCustomers"] = 1
        //MIKAEL
        this.salespersonsBase["905Is6XLiZZA2M8AdsADYLc8anP2"][2019]["months"][3]["margins"] = 12759.71
        this.salespersonsBase["905Is6XLiZZA2M8AdsADYLc8anP2"][2019]["months"][3]["sales"] = 24591
        this.salespersonsBase["905Is6XLiZZA2M8AdsADYLc8anP2"][2019]["months"][3]["orders"] = 25
        this.salespersonsBase["905Is6XLiZZA2M8AdsADYLc8anP2"][2019]["months"][3]["newCustomers"] = 25
        this.salespersonsBase["905Is6XLiZZA2M8AdsADYLc8anP2"][2019]["months"][4]["margins"] = 6953
        this.salespersonsBase["905Is6XLiZZA2M8AdsADYLc8anP2"][2019]["months"][4]["sales"] = 12566
        this.salespersonsBase["905Is6XLiZZA2M8AdsADYLc8anP2"][2019]["months"][4]["orders"] = 15
        this.salespersonsBase["905Is6XLiZZA2M8AdsADYLc8anP2"][2019]["months"][4]["newCustomers"] = 15
      }
    }
  }
</script>

<style>

.font-weight-heavy {
  font-size: 18px;
  font-weight: 500;
  letter-spacing:.0125em!important;
  font-family:Roboto,sans-serif!important;
}
</style>


// WEBPACK FOOTER //
// src/components/views/Report.vue